/**
 * CONOWAVE Quiz v4 – Konsolidiertes Briefing 17.04.2026
 *
 * Physik-Formel (Pythagoras + 0.97-Grenze), branchenabhängige Ohr-Höhe,
 * Zwischen-Screen mit Lade-Animation, gewichtete Gift-Randomisierung,
 * Zurück-Link im Content-Flow, Produktbild-Loading für Result-Cards.
 */
(function () {
  'use strict';

  // ── i18n (R3-5) ────────────────────────────────────────────────────────
  // Uebersetzungen kommen aus dem <script type="application/json" data-quiz-i18n>
  // Block der Section (conowave.quiz.* Locale-Keys). DE-Fallbacks stehen inline,
  // damit das Quiz auch ohne Block funktioniert.
  let I18N = {};
  try { const _el = document.querySelector('[data-quiz-i18n]'); if (_el) I18N = JSON.parse(_el.textContent) || {}; } catch (_) { I18N = {}; }
  const tt = (key, fb) => (I18N[key] != null && I18N[key] !== '' ? I18N[key] : fb);
  const tpl = (str, vars) => String(str).replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m));
  const PAGE_LANG = (document.documentElement.lang || 'de').toLowerCase().indexOf('en') === 0 ? 'en-US' : 'de-DE';

  // ── Meta-Pixel Conversion-Tracking ─────────────────────────────────────
  // Der Meta-Pixel laeuft in Shopifys Web-Pixel-Sandbox, NICHT im Theme-Scope
  // (fbq ist hier nicht verfuegbar). Wir feuern das Event darum ueber Shopifys
  // Event-Bus; ein Custom Pixel (Shopify Admin -> Kundenereignisse) faengt es ab
  // und ruft dort fbq('trackCustom', name). Jedes Event nur EINMAL pro Session.
  function cwTrack(name, data, dedupKey) {
    var key = 'cw_' + (dedupKey || name);
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {
      if (window[key]) return;
      window[key] = true;
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  // ── Matomo-Funnel-Events ───────────────────────────────────────────────
  // Ueber window.cwMatomo (snippets/conowave-matomo.liquid) an den Matomo-Pixel.
  // Jede Aktion feuert nur, wenn sich die Auswahl gegenueber dem zuletzt
  // gesendeten Wert geaendert hat (zurueck + neu waehlen feuert erneut).
  // Namen bewusst fest auf Deutsch - sprachunabhaengig auswertbar.
  const MTM_BRANCHE = { retail:'Einzelhandel', cafe:'Café', fitness:'Fitness', hotel:'Hotel', beauty:'Friseur', other:'Anderes' };
  const MTM_MONTAGE = { stromschiene:'Stromschiene', einbau_decke:'Decke', wand:'Wand', abhaengend:'Abgehaengt' };
  const MTM_FARBE = { silber:'Silber', weiss:'Weiss', schwarz:'Schwarz' };
  const _mtmLast = {};
  function cwMatomoKalk(action, key, name, value) {
    if (_mtmLast[action] === key) return;
    _mtmLast[action] = key;
    try { if (typeof window.cwMatomo === 'function') window.cwMatomo('Kalkulator', action, name, value); } catch (e) {}
  }
  function mtmFlaecheKlasse(qm) {
    if (qm >= 300) return '300+';
    const lo = Math.floor(qm / 50) * 50;
    const pad = n => String(n).padStart(3, '0');
    return pad(lo) + '-' + pad(lo + 49);
  }

  // Farb-/Titel-Normalisierung (umlaut- + ß-tolerant) fuer Varianten-Matching.
  const NRM = s => String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

  // ── Constants ──────────────────────────────────────────────────────────
  // Geschenk-Popup (A5): oeffnet nicht mehr auf dem Ergebnis, sondern erst beim Klick
  // auf "In den Warenkorb" / "Sofort in anderer Farbe" (siehe _giftGate).
  // Popup-Frequenz: sessionStorage = einmal pro Browser-Sitzung ("verzichtet ist
  // verzichtet"). Soll es dauerhaft pro Nutzer gelten, in _dismissGiftPopup()
  // zusaetzlich localStorage.setItem('conowave_gift_declined','true') setzen und
  // in _chkClaim() abfragen.
  // Preisstand 2026-07-26 (netto EUR) - MUSS den Shopify-Produktpreisen entsprechen:
  // der Warenkorb rechnet mit den echten Shopify-Preisen, diese Map steuert nur die Anzeige.
  const PRICES = { 'canto-smart':559,'pendo-smart':619,'cubo-smart':479,'candela-smart':469,'puro-smart':489,'luna-smart':669,'sub-canto-smart':749,'sub-quadro-smart':699,'smartplayer':499,'volumenregler-premium':79,'wandhalterung-luna':24.90 };
  const NAMES = { 'canto-smart':'canto SMART','pendo-smart':'pendo SMART','cubo-smart':'cubo SMART','candela-smart':'candela SMART','puro-smart':'puro SMART','luna-smart':'luna SMART','sub-canto-smart':'SUB canto SMART','sub-quadro-smart':'SUB quadro SMART','smartplayer':'SMARTplayer','volumenregler-premium':'Volumenregler Premium','wandhalterung-luna':'Wandhalterung luna' };
  // candela/cubo sind nicht Teil des Launches (kommen mit dem Enterprise-B2B-Shop).
  // Der 'Aufbau auf Decke'-Pfad ist komplett entfernt - PRODUCT_MAP kennt ihn nicht mehr.
  const PRODUCT_MAP = { stromschiene:{speaker:'canto-smart',sub:'sub-canto-smart'}, einbau_decke:{speaker:'puro-smart',sub:'sub-quadro-smart'}, abhaengend:{speaker:'pendo-smart',sub:'sub-quadro-smart'}, wand:{speaker:'luna-smart',sub:'sub-quadro-smart'} };
  const COLOR_AVAIL = { 'canto-smart':['silber','weiss','schwarz'],'pendo-smart':['silber','weiss','schwarz'],'cubo-smart':['silber','weiss','schwarz'],'candela-smart':['silber','weiss','schwarz'],'puro-smart':['silber','weiss','schwarz'],'luna-smart':['weiss','schwarz'],'sub-canto-smart':['weiss','schwarz'],'sub-quadro-smart':['weiss','schwarz'] };
  // Frequenzbereiche der Launch-Speaker (Quelle: Produkt-Metafeld custom.tech_daten).
  // Mit Subwoofer (SUB canto/quadro) reicht das System hinab bis 37 Hz.
  const SPK_HZ = { 'canto-smart':'105 - 21.000 Hz','puro-smart':'105 - 20.000 Hz','pendo-smart':'105 - 21.000 Hz','luna-smart':'50 - 21.000 Hz','candela-smart':'105 - 21.000 Hz','cubo-smart':'105 - 21.000 Hz' };
  const SUB_HZ_LOW = '37';
  // Einmaliges Test-System-Angebot (netto). NUR fuer Canto/Stromschiene: klein = 1 Canto + SMARTplayer,
  // gross (ab 5 empfohlenen Speakern) = 1 Canto + SMARTplayer + Subwoofer. Fuer andere Montagearten
  // (Puro/Pendo/Luna) gilt es nicht (dort liegt der Festpreis teils unter/ueber Liste) -> dort normaler Preis.
  const TEST_OFFER = { small: 995, big: 1695 };
  const COLOR_LBL = { silber:tt('farbe_silber','Silber'), weiss:tt('farbe_weiss','Weiß'), schwarz:tt('farbe_schwarz','Schwarz') };
  // B4: immer der ERSTE Begriff der Branchen-Card ("Friseur, Kosmetik, Praxis" -> "Friseur")
  const BRANCHE_LBL = { retail:tt('branche_lbl_retail','Einzelhandel'), cafe:tt('branche_lbl_cafe','Café'), fitness:tt('branche_lbl_fitness','Fitness'), hotel:tt('branche_lbl_hotel','Hotel'), beauty:tt('branche_lbl_beauty','Friseur'), other:tt('branche_lbl_other','Anderes') };
  const MONTAGE_LBL = { stromschiene:tt('montage_stromschiene','Stromschiene'), einbau_decke:tt('montage_einbau_decke','Einbau Decke'), abhaengend:tt('montage_abhaengend','Abhängend'), wand:tt('montage_wand','Wand') };
  const INSTALL_TXT = (() => {
    const t1=tt('install_stromschiene_t','Installation: 1–3 Min. pro Speaker'), t4=tt('install_aufbau_t','Installation: 4–5 Min. pro Speaker');
    return {
      stromschiene: { t:t1, s:tt('install_stromschiene_s','So einfach wie eine Deckenlampe anbringen. Auspacken, einklicken, verbinden. Kein Werkzeug nötig.') },
      aufbau_candela: { t:t4, s:tt('install_aufbau_s','Montage wie eine Deckenlampe.') },
      aufbau_cubo: { t:t4, s:tt('install_aufbau_s','Montage wie eine Deckenlampe.') },
      einbau_decke: { t:t4, s:tt('install_einbau_s','Einbau wie eine Deckenlampe.') },
      abhaengend: { t:t4, s:tt('install_abhaengend_s','Seilabhängung direkt an deiner Deckenkonstruktion.') },
      wand: { t:tt('install_wand_t','Installation: Aufstellen oder Wandmontage'), s:tt('install_wand_s','Flexibel – freistehend oder mit beiliegender Wandhalterung.') }
    };
  })();
  const BUNDLE_COPY = {
    base: tt('copy_starter','Ausgewogene Höhen und Mitten durch unsere 360°-Speaker.'),
    empfohlen: tt('copy_starter','Ausgewogene Höhen und Mitten durch unsere 360°-Speaker.'),
    premium: tt('copy_komplett','Das komplette System. Der Subwoofer ergänzt die tiefen Frequenzen – der Raum wird spürbar gefüllt.')
  };
  const HEIGHT_TEXT = {
    cafe: tt('height_cafe',''), hotel: tt('height_hotel',''), retail: tt('height_retail',''),
    fitness: tt('height_fitness',''), beauty: tt('height_beauty',''), other: tt('height_other','')
  };

  // Branchen-spezifischer Genitiv fuer "Aus den Eckdaten ___ ergibt sich..."
  const BRANCHE_GENITIV = {
    cafe: tt('genitiv_cafe','deiner Gastronomie'), retail: tt('genitiv_retail','deines Stores'),
    fitness: tt('genitiv_fitness','deines Studios'), hotel: tt('genitiv_hotel','deines Hotels'),
    beauty: tt('genitiv_beauty','deiner Praxis'), other: tt('genitiv_other','deines Geschäfts')
  };

  const RESULT_HEADLINE = {
    cafe: tt('headline_cafe','Unsere persönliche Empfehlung für deine Gastronomie'),
    retail: tt('headline_retail','Unsere persönliche Empfehlung für deinen Store'),
    fitness: tt('headline_fitness','Unsere persönliche Empfehlung für dein Studio'),
    hotel: tt('headline_hotel','Unsere persönliche Empfehlung für deine Räumlichkeiten'),
    beauty: tt('headline_beauty','Unsere persönliche Empfehlung für deine Praxis'),
    other: tt('headline_other','Unsere persönliche Empfehlung')
  };

  const PRODUCT_INFO = {
    'smartplayer': tt('pi_smartplayer','Verstärker, Streamer und Funksender in einem Gerät.'),
    'canto-smart': tt('pi_canto','360° Funk-Lautsprecher für Stromschienen.'),
    'sub-canto-smart': tt('pi_sub_canto','Funk-Subwoofer für die Stromschiene.'),
    'candela-smart': tt('pi_candela','360° Funk-Deckenlautsprecher zum Aufschrauben.'),
    'cubo-smart': tt('pi_cubo','360° Funk-Deckenlautsprecher zum Aufschrauben. Quadratisches Design.'),
    'puro-smart': tt('pi_puro','360° Funk-Einbaulautsprecher für die Decke.'),
    'pendo-smart': tt('pi_pendo','360° Funk-Pendellautsprecher. Abhängend.'),
    'luna-smart': tt('pi_luna','360° Funk-Lautsprecher für Regal oder Wand.'),
    'sub-quadro-smart': tt('pi_sub_quadro','Funk-Subwoofer für Decken- und Wandmontage.'),
    'volumenregler-premium': tt('pi_vol','Manuelle Lautstärkeregelung direkt am Gerät.'),
    'wandhalterung-luna': tt('pi_wandhalterung','Wandhalterung für luna SMART.')
  };

  // ── Helpers ─────────────────────────────────────────────────────────────
  const fmtEur = n => { const f = Math.round(n*100)/100; return new Intl.NumberFormat(PAGE_LANG,{style:'currency',currency:'EUR',minimumFractionDigits:f%1===0?0:2,maximumFractionDigits:2}).format(f); };
  const fmtM = n => new Intl.NumberFormat(PAGE_LANG,{minimumFractionDigits:1,maximumFractionDigits:1}).format(Number(n));
  const validEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim());
  const esc = s => String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const setCk = (n,v,d)=>{ const e=new Date(); e.setTime(e.getTime()+d*864e5); document.cookie=`${n}=${v}; expires=${e.toUTCString()}; path=/; SameSite=Lax`; };
  const getCk = n=>{ const m=document.cookie.split(';').map(s=>s.trim()).find(s=>s.startsWith(n+'=')); return m?m.slice(n.length+1):null; };

  // Shopify rich_text (JSON) -> HTML. Nur die im Shop genutzten Knoten; Zeilenumbrueche
  // innerhalb eines Absatzes werden zu <br>. Fail-safe: ungueltiges JSON -> leer.
  function richTextToHtml(jsonStr){
    let root; try{ root=JSON.parse(jsonStr); }catch(_){ return ''; }
    const inl=n=>{ if(n.type==='text'){ let t=esc(n.value||'').replace(/\n/g,'<br>'); if(n.bold)t=`<strong>${t}</strong>`; if(n.italic)t=`<em>${t}</em>`; return t; } return (n.children||[]).map(inl).join(''); };
    const blk=n=>{ switch(n.type){
      case 'root': return (n.children||[]).map(blk).join('');
      case 'paragraph': { const t=(n.children||[]).map(inl).join(''); return t?`<p>${t}</p>`:''; }
      case 'heading': return `<h4>${(n.children||[]).map(inl).join('')}</h4>`;
      case 'list': return `<${n.listType==='ordered'?'ol':'ul'}>${(n.children||[]).map(blk).join('')}</${n.listType==='ordered'?'ol':'ul'}>`;
      case 'list-item': return `<li>${(n.children||[]).map(inl).join('')}</li>`;
      default: return (n.children||[]).map(blk).join('');
    } };
    return blk(root);
  }

  // Physik-Formel: Pythagoras + inkrementelle Distanz mit Qualitätsgrenze 0.97
  // Lineare Interpolation zwischen Patricks validierten Datenpunkten.
  // Ohrhöhe verschiebt die effektive Installationshöhe.
  function qmProSpeaker(installH, branche) {
    const ear = ['cafe','hotel'].includes(branche) ? 1.20 : 1.55;
    const h = installH - ear + 1.55; // Normalisiert auf "stehend"-Skala
    if (h <= 2.7) return 30;
    if (h <= 3.2) return 30 + (50 - 30) * ((h - 2.7) / (3.2 - 2.7));
    if (h <= 4.0) return 50 + (80 - 50) * ((h - 3.2) / (4.0 - 3.2));
    return 80 + (h - 4.0) * 15;
  }

  function roundSpeakers(raw, installH) {
    // Unter 2 Speaker: immer aufrunden. 1 Speaker fuer einen Raum der 1,1 Speaker braucht = Luecke.
    if (raw < 2) return Math.max(1, Math.ceil(raw));
    // Ab 2+: Schwelle-basiertes Runden (hohe Decken toleranter)
    const dec = raw - Math.floor(raw);
    const th = installH >= 3.5 ? 0.5 : 0.3;
    return dec <= th ? Math.floor(raw) : Math.ceil(raw);
  }

  // Gewichtete Randomisierung
  function weightedRoll(weights, startVal) {
    const total = weights.reduce((a,b)=>a+b,0);
    let r = Math.random()*total;
    for (let i=0;i<weights.length;i++) { r-=weights[i]; if(r<=0) return startVal+i; }
    return startVal;
  }
  // A: 8-15%, >12% nur in 1/10 Faellen
  function rollA() { return weightedRoll([22,22,20,15,11,5,3,2], 8); }
  // B: nur Garantie, 1-4 Jahre Zusatz, +4 nur in ~10% der Faelle
  function rollGarantieB() { return weightedRoll([20,30,30,10], 1); }

  // ── Custom Element ──────────────────────────────────────────────────────
  class CQ extends HTMLElement {
    constructor() {
      super();
      this._vc={}; this._prodImg={}; this._hist=[]; this._fwd=[]; this._loc='1'; this._gs='picking'; this._visitedSteps=new Set();
      this.S = {
        branche:null, raumgroesse:0, deckenhoehe_m:2.7,
        montage_schiene:null, schiene_platzierung:null, montage_typ:null,
        abhaengung_cm:0, installH:2.7, qmps:25, ohrH:1.55,
        farbe:null,
        giftKat:null, email:null, discPct:null, garZus:0, garGes:2, discCode:null,
        installWanted:false, giftClaimed:false, dirty:false, giftWasReclaimed:false
      };
    }

    connectedCallback() {
      this._chkClaim();
      try{this._prodImg=JSON.parse(this.dataset.productImages||'{}');}catch(_){this._prodImg={};}
      this._mountModalsToBody();
      this._bindOpts(); this._bindArea(); this._bindHeight(); this._bindAbh();
      this._bindNexts(); this._bindCalc(); this._bindGiftCards(); this._bindGiftForm(); this._bindGiftModal();
      this._bindModal(); this._bindSaveModal(); this._bindBack(); this._bindStepNav(); this._bindSidebarNav();
      this._bindAltColor(); this._bindReserve();
      this._bindDev();
      this._updArea(this.S.raumgroesse); this._updAreaNext(); this._updHeight(2.7);
      window.addEventListener('beforeunload', e => { if(this.S.dirty && !['result','7'].includes(this._loc)){e.preventDefault();e.returnValue='';} });
      window.addEventListener('pageshow', (e) => { if(e.persisted && this._loc==='result') this._renderResult(); });
      // Browser-Vor/Zurueck wirkt als Konfigurator-Vor/Zurueck (A1)
      window.addEventListener('popstate', (e) => {
        let loc = (e.state && e.state.cwLoc) || new URLSearchParams(window.location.search).get('step');
        if(!loc) return;
        if(loc==='gift') loc='result';
        if((loc==='result'||loc==='summary') && !this._isComplete()) loc=this._firstIncompleteStep();
        // Pfeil-Stacks nachziehen, damit die Vor/Zurueck-Pfeile konsistent bleiben
        if(this._hist.length && this._hist[this._hist.length-1]===loc){ this._hist.pop(); this._fwd.push(this._loc); }
        else if(this._fwd.length && this._fwd[this._fwd.length-1]===loc){ this._fwd.pop(); this._hist.push(this._loc); }
        this._nav(loc, false);
      });

      let lookupCode = window.__cw_lookup_code || new URLSearchParams(window.location.search).get('code');
      if(!lookupCode) try{lookupCode=sessionStorage.getItem('cw_lookup_code');}catch(_){}
      if(lookupCode) { try{sessionStorage.removeItem('cw_lookup_code');}catch(_){} this._lookupAndShow(lookupCode); return; }

      // Reihenfolge: Session-State (reichhaltigster Stand) laden, URL-Parameter
      // darueber legen (geteilter Link / Browser-Navigation), dann navigieren.
      const sessionLoc = this._restoreStateFromSession();
      const urlLoc = this._applyUrlParams();
      if(urlLoc) { this._nav(urlLoc, false); return; }
      if(sessionLoc) { this._nav(sessionLoc, false); }
      // KalkulatorStart: erste Frage sichtbar (frischer Load bleibt statisch auf Schritt 1).
      if(this._loc==='1') cwTrack('KalkulatorStart');
    }

    async _lookupAndShow(code) {
      const workerUrl = this.dataset.workerUrl || 'https://conowave-quiz-worker.conowave.workers.dev';
      try {
        const res = await fetch(workerUrl+'/lookup', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({ code })
        });
        if(!res.ok) { this._restoreFromSession(); return; }
        const d = await res.json();
        const q = d.quiz_data || {};
        this.S.branche = q.branche || 'other';
        this.S.raumgroesse = q.flaeche_qm || 60;
        this.S.deckenhoehe_m = q.deckenhoehe_m || 2.7;
        this.S.abhaengung_cm = q.abhaengung_cm || 0;
        this.S.montage_typ = q.montage || null;
        this.S.farbe = q.farbe || 'weiss';
        this.S.installH = q.installationshoehe_m || this.S.deckenhoehe_m;
        this.S.qmps = q.qm_pro_speaker || qmProSpeaker(this.S.installH, this.S.branche);
        this.S.ohrH = q.ohr_hoehe || (['cafe','hotel'].includes(this.S.branche) ? 1.20 : 1.55);
        if (d.code_expired) {
          this.S.giftKat = null;
          this.S.discPct = null;
          this.S.garZus = 0;
          this.S.garGes = 2;
          this.S.discCode = null;
        } else {
          this.S.giftKat = d.geschenk_typ;
          this.S.discPct = d.rabatt_prozent;
          this.S.garZus = d.garantie_zusatz_jahre || 0;
          this.S.garGes = d.gesamte_garantie_jahre || 2;
          this.S.discCode = d.discount_code;
        }
        this.S.giftClaimed = true;
        this._recomp();
        this._nav('result');
      } catch(_) {
        this._restoreFromSession();
      }
    }

    _restoreFromSession() {
      const loc = this._restoreStateFromSession();
      if(loc) this._nav(loc, false);
    }

    // Stellt NUR den State aus sessionStorage wieder her (kein nav).
    // Rueckgabe: gespeicherte Location oder null.
    _restoreStateFromSession() {
      try {
        const saved = sessionStorage.getItem('cw_quiz_state');
        if(!saved) return null;
        const d = JSON.parse(saved);
        if(!d || !d.loc || !d.S) return null;
        Object.assign(this.S, d.S);
        // Entfallene Montage-Typen (z.B. aufbau_candela/cubo aus alten Sessions)
        // sauber zuruecksetzen, sonst wuerde das Result-Rendering crashen.
        if(this.S.montage_typ && !PRODUCT_MAP[this.S.montage_typ]){
          this.S.montage_typ=null; this.S.montage_schiene=null; this.S.schiene_platzierung=null;
        }
        this._hist = d.hist || [];
        this._visitedSteps = new Set([1,2,3,4,5]);
        let loc = d.loc === 'gift' ? 'result' : d.loc;
        if((loc==='result'||loc==='summary') && !this._isComplete()) loc=this._firstIncompleteStep();
        return loc;
      } catch(_) { return null; }
    }

    // ── URL-State (A1) ─────────────────────────────────────────────────────
    // Liest Konfigurator-Parameter aus der URL und legt sie ueber den State.
    // Rueckgabe: Ziel-Location aus ?step=... oder null wenn keine Quiz-Parameter da sind.
    _applyUrlParams() {
      const q = new URLSearchParams(window.location.search);
      const hasParams = ['step','branche','flaeche','hoehe','montage','farbe'].some(k => q.has(k));
      if(!hasParams) return null;
      const s = this.S;
      const num = v => { const n = parseFloat(String(v).replace(',','.')); return isNaN(n) ? null : n; };
      const BRANCHEN = ['retail','cafe','fitness','hotel','beauty','other'];
      const MONTAGEN = ['stromschiene','einbau_decke','abhaengend','wand'];
      const FARBEN = ['silber','weiss','schwarz'];
      if(BRANCHEN.includes(q.get('branche'))) s.branche = q.get('branche');
      if(q.has('flaeche')) { const f = Math.round(num(q.get('flaeche')) || 0); s.raumgroesse = f > 0 ? f : s.raumgroesse; }
      if(q.has('hoehe')) { const h = num(q.get('hoehe')); if(h) s.deckenhoehe_m = Math.min(6, Math.max(2, h)); }
      if(q.has('abh')) { const a = Math.round(num(q.get('abh')) || 0); s.abhaengung_cm = a > 0 ? a : 0; }
      if(MONTAGEN.includes(q.get('montage'))) s.montage_typ = q.get('montage');
      if(['decke','abgehaengt'].includes(q.get('platz'))) s.schiene_platzierung = q.get('platz');
      if(s.montage_typ === 'stromschiene') {
        s.montage_schiene = 'ja';
        if(!s.schiene_platzierung) s.schiene_platzierung = s.abhaengung_cm > 0 ? 'abgehaengt' : 'decke';
      } else if(s.montage_typ) {
        s.montage_schiene = 'nein';
      }
      if(FARBEN.includes(q.get('farbe'))) s.farbe = q.get('farbe');
      if(s.branche) s.ohrH = ['cafe','hotel'].includes(s.branche) ? 1.20 : 1.55;
      this._recomp();
      if(s.branche) this._visitedSteps.add(1);
      if(s.raumgroesse > 0) this._visitedSteps.add(2);
      this._visitedSteps.add(3);
      if(s.montage_typ) this._visitedSteps.add(4);
      if(s.farbe) this._visitedSteps.add(5);
      const VALID = ['1','2','3','4-schiene','4-schiene_placement','4-abhaengung','4-typ','4-wand_info','5','summary','result'];
      let step = q.get('step') || this._firstIncompleteStep();
      if(step === 'gift') step = 'result';
      if(!VALID.includes(step)) step = '1';
      if((step === 'result' || step === 'summary') && !this._isComplete()) step = this._firstIncompleteStep();
      return step;
    }

    // Baut die URL mit den aktuellen Quiz-Parametern. Fremde Parameter bleiben erhalten.
    _buildUrl(loc) {
      const q = new URLSearchParams(window.location.search);
      const s = this.S;
      const set = (k, v) => { if(v === null || v === undefined || v === '' || v === 0) q.delete(k); else q.set(k, String(v)); };
      set('step', loc);
      set('branche', s.branche);
      set('flaeche', s.raumgroesse > 0 ? s.raumgroesse : null);
      set('hoehe', s.deckenhoehe_m);
      set('abh', s.abhaengung_cm > 0 ? s.abhaengung_cm : null);
      set('montage', s.montage_typ);
      set('platz', s.montage_typ === 'stromschiene' ? s.schiene_platzierung : null);
      set('farbe', s.farbe);
      const qs = q.toString();
      return window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    }

    // ── Vollstaendigkeit (A4) ─────────────────────────────────────────────
    _isComplete() {
      const s = this.S;
      return !!(s.branche && s.raumgroesse > 0 && s.deckenhoehe_m && s.montage_typ && s.farbe);
    }
    _firstIncompleteStep() {
      const s = this.S;
      if(!s.branche) return '1';
      if(!(s.raumgroesse > 0)) return '2';
      if(!s.deckenhoehe_m) return '3';
      if(!s.montage_typ) return '4-schiene';
      if(!s.farbe) return '5';
      return 'summary';
    }

    // ── Gate (3-tier: cookie > sessionStorage > fresh) ─────────────────────
    _chkClaim() {
      // Tier 1: Cookie/localStorage = mail sent, fully claimed. Geschenk-WERT mit wiederherstellen,
      // damit das 5%-/Garantie-Feld nach Reload erhalten bleibt (Popup poppt dank Flag nicht erneut).
      const restoreGift=()=>{try{const gd=JSON.parse(localStorage.getItem('conowave_gift_data')||'null');if(gd){this.S.giftKat=gd.typ||null;this.S.discPct=gd.rabatt||null;this.S.discCode=gd.code||null;this.S.garZus=gd.garZus||0;this.S.garGes=2+(gd.garZus||0);}}catch(_){}};
      try{if(getCk('cw_gift_claimed')==='true'){this.S.giftClaimed=true;restoreGift();return;}}catch(_){}
      try{if(localStorage.getItem('conowave_gift_claimed')==='true'){this.S.giftClaimed=true;restoreGift();return;}}catch(_){}
      // Tier 2: sessionStorage declined = bewusst abgelehnt
      try{if(sessionStorage.getItem('cw_gift_declined')==='true'){this.S.giftDeclined=true;return;}}catch(_){}
      // Tier 3: sessionStorage = card picked, mail not yet sent
      try{
        const saved=sessionStorage.getItem('cw_gift_value');
        if(saved){const g=JSON.parse(saved);this.S.giftKat=g.typ;this.S.discPct=g.rabatt;this.S.garZus=g.garantie_zusatz;this.S.garGes=2+g.garantie_zusatz;this._giftFromSession=true;}
      }catch(_){}
    }
    _saveGiftSession(typ,rabatt,garZus){try{sessionStorage.setItem('cw_gift_value',JSON.stringify({typ,rabatt,garantie_zusatz:garZus,timestamp:Date.now()}));}catch(_){}}
    _clearGiftSession(){try{sessionStorage.removeItem('cw_gift_value');}catch(_){}}
    // Geschenk-Wert persistent sichern (localStorage), damit die Ergebnisseite ihn nach Reload behaelt.
    _persistGiftData(){try{localStorage.setItem('conowave_gift_data',JSON.stringify({typ:this.S.giftKat,rabatt:this.S.discPct||0,code:this.S.discCode||null,garZus:this.S.garZus||0}));}catch(_){}}
    _markClaim(){this.S.giftClaimed=true;this._clearGiftSession();try{setCk('cw_gift_claimed','true',180);}catch(_){}try{localStorage.setItem('conowave_gift_claimed','true');}catch(_){}this._persistGiftData();}

    // ── Nav ───────────────────────────────────────────────────────────────
    _nav(loc, push=true) {
      if(push && this._loc && this._loc!==loc) this._hist.push(this._loc);
      if(push) this._fwd=[]; // neuer Pfad macht "Vor" ungueltig
      this._loc=loc; this.S.dirty=true;
      this._show(loc); this._updBackVis(); this._updSidebar();
      // State in sessionStorage sichern fuer F5-Reload
      try{sessionStorage.setItem('cw_quiz_state',JSON.stringify({loc:this._loc,S:this.S,hist:this._hist}));}catch(_){}
      // URL-State (A1): Schritt + Angaben in die Query schreiben
      try{
        const url=this._buildUrl(loc);
        if(push) history.pushState({cwLoc:loc},'',url);
        else history.replaceState({cwLoc:loc},'',url);
      }catch(_){}
      try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'quiz_step',location:loc});}catch(_){}
    }

    _show(loc) {
      // Parse: '1','2','3','4-schiene','summary','gift','result' etc.
      const [stepRaw,sub] = loc.split('-');
      const isNum = !isNaN(Number(stepRaw));
      const stepAttr = isNum ? stepRaw : loc.split('-')[0]; // 'summary','gift','result'

      this.querySelectorAll('.cw-quiz__panel').forEach(p => {
        const ps = p.dataset.step;
        p.classList.toggle('is-active', ps===stepAttr || (isNum && ps===stepRaw));
      });

      if(sub) {
        const panel = this.querySelector(`[data-step="${stepRaw}"]`);
        if(panel) panel.querySelectorAll('.cw-quiz__subpanel').forEach(s=>s.classList.toggle('is-active',s.dataset.subpanel===sub));
      }

      // Dots: Schritte 1-5 UND Zusammenfassung (dort alle als erledigt, R2-3)
      const step = Number(stepRaw);
      const onSummary = stepAttr==='summary';
      const showDots = (isNum && step<=5) || onSummary;
      const progEl = this.querySelector('.cw-quiz__progress');
      if(progEl) progEl.style.display = showDots?'':'none';
      if(showDots) this.querySelectorAll('.cw-quiz__progress li').forEach(li=>{const d=Number(li.dataset.dot);li.classList.toggle('is-active',!onSummary&&d===step);li.classList.toggle('is-done',onSummary||d<step);});

      // Stage
      if(loc==='result') this.setAttribute('data-stage','result');
      else if(loc==='summary') this.setAttribute('data-stage','summary');
      else this.removeAttribute('data-stage');

      const stepNum = parseInt(stepAttr,10);
      if(!isNaN(stepNum)) {
        this._visitedSteps.add(stepNum);
        // Schritt-Event: 1x pro Schritt pro Session (Dedup-Key traegt die Nummer, Name bleibt gleich).
        cwTrack('KalkulatorSchritt', {schritt: stepNum}, 'KalkulatorSchritt_' + stepNum);
        if(stepNum===1) cwTrack('KalkulatorStart');
      }
      this._restoreUI(stepAttr, sub);
      // Mobil: Oberkante des aktiven Kastens direkt unter den (Sticky-)Banner
      // scrollen - so ist beim Schrittwechsel immer der ganze Kasten im Blick.
      // Desktop + Ergebnis: wie bisher ganz nach oben.
      const _isMobileNav = (()=>{try{return window.matchMedia('(max-width: 1023px)').matches;}catch(_){return false;}})();
      const _act = this.querySelector('.cw-quiz__panel.is-active');
      if(_isMobileNav && _act && loc!=='result'){
        // Banner (Sticky-Header) verdeckt sonst die Kasten-Oberkante. --sticky-header-height
        // ist erst nach echtem Scrollen gesetzt, darum die aktuell sichtbare Banner-Hoehe
        // live messen: getBoundingClientRect().bottom = 0 wenn kein Banner ueberlappt,
        // sonst dessen Unterkante. So beginnt der Kasten exakt darunter.
        let _off = 0;
        try {
          const _h = document.querySelector('header.header') || document.querySelector('.header-section');
          if(_h) _off = Math.max(0, _h.getBoundingClientRect().bottom);
          if(!_off) _off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        } catch(_) {}
        const _top = (window.scrollY || window.pageYOffset || 0) + _act.getBoundingClientRect().top - _off - 12;
        try { window.scrollTo({top: Math.max(0,_top), behavior:'smooth'}); }
        catch(_) { window.scrollTo(0, Math.max(0,_top)); }
      } else {
        window.scrollTo({top:0,behavior:'smooth'});
      }
      if(loc==='summary') this._populateSummary();
      if(loc==='result') this._renderResult();
    }

    _populateSummary(){
      const s=this.S;
      const parts=[BRANCHE_LBL[s.branche]||s.branche,`${s.raumgroesse} m²`,`${tt('lbl_decke','Deckenhöhe')} ${fmtM(s.deckenhoehe_m)} m`,MONTAGE_LBL[s.montage_typ],COLOR_LBL[s.farbe]];
      const el=this.querySelector('[data-summary-line]');
      if(el) el.textContent=parts.join(' · ');

      // Button: "Neu berechnen" wenn schon mal berechnet
      const btn=this.querySelector('[data-action="calculate"]');
      if(btn && this._hasCalced){const bt=btn.querySelector('.btn-text')||btn;bt.textContent=tt('recalc_btn','Neu berechnen');}

      // Vergleich: was hat sich geändert?
      const diffEl=this.querySelector('[data-summary-diff]');
      if(diffEl && this._lastSummary) {
        const oldParts=this._lastSummary;
        const changes=[];
        const dl=[tt('lbl_branche','Branche'),tt('lbl_flaeche','Fläche'),tt('lbl_decke','Deckenhöhe'),tt('lbl_montage','Montage'),tt('lbl_farbe','Farbe')];
        for(let di=0;di<5;di++){ if(oldParts[di]!==parts[di]) changes.push(`${dl[di]}: ${oldParts[di]} → ${parts[di]}`); }
        diffEl.innerHTML = changes.length
          ? `<p class="cw-quiz__diff-title">${esc(tt('diff_title','Geändert:'))}</p>${changes.map(c=>`<p class="cw-quiz__diff-item">${esc(c)}</p>`).join('')}`
          : `<p class="cw-quiz__diff-none">${esc(tt('diff_none','Keine Änderungen – deine Empfehlung bleibt gleich.'))}</p>`;
        diffEl.hidden=false;
      }
      this._lastSummary=parts;
    }

    _restoreUI(step, sub) {
      const p = this.querySelector(`[data-step="${step}"]`);
      if(!p) return;
      p.querySelectorAll('[data-field]').forEach(g=>{
        const v=this.S[g.dataset.field];
        g.querySelectorAll('.cw-quiz__option,.cw-quiz__gift-card').forEach(b=>{
          const m=b.dataset.value===v||b.dataset.value===String(v);
          b.setAttribute('aria-checked',String(m)); b.classList.toggle('is-selected',m);
        });
      });
      if(step==='2'){
        const s=this.querySelector('[data-field="raumgroesse-slider"]');
        if(s){s.value=Math.min(this.S.raumgroesse||0,1000);this._styleSlider(s);}
        const i=this.querySelector('[data-field="raumgroesse"]');
        if(i)i.value=this.S.raumgroesse>0?this.S.raumgroesse:'';
        this._updArea(this.S.raumgroesse);this._updAreaNext();
      }
      if(step==='3'){ const s=this.querySelector('[data-field="deckenhoehe-slider"]');if(s){s.value=this.S.deckenhoehe_m;this._styleSlider(s);}this._updHeight(this.S.deckenhoehe_m);this._updHeightText(); }
      if(step==='4'&&sub==='abhaengung') this._updAbhNext();
      if(step==='5') this._updColors();
    }

    goBack() {
      if(['result','7'].includes(this._loc)) return false;
      if(!this._hist.length) return false;
      this._fwd.push(this._loc);
      this._nav(this._hist.pop(), false);
      return true;
    }

    goFwd() {
      if(!this._fwd.length) return false;
      if(this._loc==='2') this._mtmFlaeche();
      const nxt = this._fwd.pop();
      if(this._loc && this._loc!==nxt) this._hist.push(this._loc);
      this._nav(nxt, false);
      return true;
    }

    _bindBack() {
      const btn = this.querySelector('[data-cw-back]');
      if(!btn) return;
      btn.addEventListener('click', e=>{
        e.preventDefault();
        if(!this.goBack()) window.location.href=this.dataset.homeUrl||'/';
      });
    }

    _updBackVis() {
      const locked = ['result','7'].includes(this._loc);
      const hasHist = this._hist.length > 0;
      const btn = this.querySelector('[data-cw-back]');
      if(btn) btn.hidden = locked || !hasHist;
      // Schritt-Navigation oben (A2) + "Berechnen" ueberall (A4)
      const nav = this.querySelector('[data-stepnav]');
      if(nav) {
        const prev = nav.querySelector('[data-nav-prev]');
        const next = nav.querySelector('[data-nav-next]');
        const calc = nav.querySelector('[data-nav-calc]');
        const showPrev = !locked && hasHist;
        const showNext = !locked && this._fwd.length > 0;
        const showCalc = !locked && this._loc !== 'summary' && this._isComplete();
        if(prev) prev.hidden = !showPrev;
        if(next) next.hidden = !showNext;
        if(calc) calc.hidden = !showCalc;
      }
    }

    _bindStepNav() {
      const nav = this.querySelector('[data-stepnav]');
      if(!nav) return;
      nav.querySelector('[data-nav-prev]')?.addEventListener('click', () => this.goBack());
      nav.querySelector('[data-nav-next]')?.addEventListener('click', () => this.goFwd());
      nav.querySelector('[data-nav-calc]')?.addEventListener('click', () => { this._nav('summary'); this._runLoading(); });
    }

    // Sidebar-Zeilen klickbar: springt zum jeweiligen Schritt (A3)
    _bindSidebarNav() {
      const map = { branche:'1', flaeche:'2', decke:'3', montage:'4-schiene', farbe:'5' };
      this.querySelectorAll('[data-sidebar-row]').forEach(row => {
        row.classList.add('is-clickable');
        row.addEventListener('click', () => {
          const target = map[row.dataset.sidebarRow];
          if(target && this._loc !== target) this._nav(target);
        });
      });
    }

    // ── Options ───────────────────────────────────────────────────────────
    _bindOpts() {
      this.querySelectorAll('[data-field] .cw-quiz__option').forEach(btn=>{
        btn.addEventListener('click',()=>{
          if(btn.hasAttribute('disabled')) return;
          const g=btn.closest('[data-field]'),f=g.dataset.field,v=btn.dataset.value;
          g.querySelectorAll('.cw-quiz__option').forEach(o=>{o.setAttribute('aria-checked','false');o.classList.remove('is-selected');});
          btn.setAttribute('aria-checked','true');btn.classList.add('is-selected');
          this.S[f]=v;
          this._updSidebar();
          this._afterOpt(f,v);
        });
      });
    }

    _afterOpt(f,v) {
      switch(f) {
        case 'branche':
          cwMatomoKalk('branche_gewaehlt', v, MTM_BRANCHE[v]||v);
          this.S.ohrH=['cafe','hotel'].includes(v)?1.20:1.55;
          this._recomp();
          setTimeout(()=>this._nav('2'),200);
          break;
        case 'montage_schiene':
          setTimeout(()=>this._nav(v==='ja'?'4-schiene_placement':'4-typ'),350);
          break;
        case 'schiene_platzierung':
          this.S.montage_typ='stromschiene';
          cwMatomoKalk('montage_gewaehlt', 'stromschiene', MTM_MONTAGE.stromschiene);
          if(v==='decke'){this.S.abhaengung_cm=0;this._recomp();setTimeout(()=>this._nav('5'),200);}
          else setTimeout(()=>this._nav('4-abhaengung'),200);
          break;
        case 'montage_typ':
          cwMatomoKalk('montage_gewaehlt', v, MTM_MONTAGE[v]||v);
          if(v==='abhaengend') setTimeout(()=>this._nav('4-abhaengung'),200);
          else if(v==='wand'){this.S.abhaengung_cm=0;this._recomp();this._updColors();setTimeout(()=>this._nav('4-wand_info'),200);}
          else{this.S.abhaengung_cm=0;this._recomp();this._updColors();setTimeout(()=>this._nav('5'),200);}
          break;
        case 'farbe':
          cwMatomoKalk('farbe_gewaehlt', v, MTM_FARBE[v]||v);
          setTimeout(()=>this._nav('summary'),200);
          break;
      }
    }

    // ── Area (Step 2) ─────────────────────────────────────────────────────
    // Kein Vorgabewert (A6): raumgroesse startet mit null, "Weiter" bleibt gesperrt
    // bis ein Wert gesetzt ist. Slider und Zahlenfeld sind immer synchron.
    _bindArea() {
      const inp=this.querySelector('[data-field="raumgroesse"]'), sl=this.querySelector('[data-field="raumgroesse-slider"]');
      sl.addEventListener('input',()=>{this.S.raumgroesse=parseInt(sl.value,10);this._updArea(this.S.raumgroesse);this._styleSlider(sl);this._updSidebar();if(inp)inp.value=sl.value;this._updAreaNext();});
      inp.addEventListener('input',()=>{
        const v=parseInt(inp.value,10);
        if(!isNaN(v)&&v>0){this.S.raumgroesse=v;sl.value=Math.min(Math.max(v,0),1000);this._updArea(v);this._styleSlider(sl);}
        else{this.S.raumgroesse=0;sl.value=0;this._updArea(0);this._styleSlider(sl);}
        this._updSidebar();this._updAreaNext();
      });
      this._styleSlider(sl);
    }
    _updArea(v){const el=this.querySelector('[data-area-display]');if(el)el.textContent=(v&&v>0)?v:'0';}
    _updAreaNext(){const b=this.querySelector('[data-action="next"][data-from="2"]');if(b)b.disabled=!(this.S.raumgroesse>0);this._updBackVis();}

    // ── Height (Step 3) ───────────────────────────────────────────────────
    _bindHeight() {
      const sl=this.querySelector('[data-field="deckenhoehe-slider"]');
      if(sl) { sl.addEventListener('input',()=>{this.S.deckenhoehe_m=parseFloat(sl.value);this._updHeight(this.S.deckenhoehe_m);this._styleSlider(sl);this._updSidebar();}); this._styleSlider(sl); }
    }
    _updHeight(v) {
      const el=this.querySelector('[data-height-display]');if(el)el.textContent=fmtM(v);
      this._recomp();
      this._updHeightText();
    }
    _updHeightText() {
      const el=this.querySelector('[data-height-branche-text]');
      if(el) el.textContent = HEIGHT_TEXT[this.S.branche] || HEIGHT_TEXT.other;
    }

    // ── Abhaengung (Step 4) ───────────────────────────────────────────────
    _bindAbh() {
      const inp=this.querySelector('[data-field="abhaengung_cm"]'), qs=this.querySelectorAll('[data-abh-quick]');
      qs.forEach(b=>b.addEventListener('click',()=>{const v=parseInt(b.dataset.abhQuick,10);inp.value=v;this.S.abhaengung_cm=v;qs.forEach(x=>x.classList.toggle('is-selected',x===b));this._updAbhNext();}));
      inp.addEventListener('input',()=>{const v=parseInt(inp.value,10);qs.forEach(b=>b.classList.remove('is-selected'));this.S.abhaengung_cm=(!isNaN(v)&&v>0)?v:0;this._updAbhNext();});
    }
    _updAbhNext(){const b=this.querySelector('[data-from="4-abh"]');if(b)b.disabled=!(this.S.abhaengung_cm>0);}

    // ── Nexts ─────────────────────────────────────────────────────────────
    _bindNexts() {
      this.querySelectorAll('[data-action="next"]').forEach(btn=>btn.addEventListener('click',()=>{
        const f=btn.dataset.from;
        if(f==='2'&&this.S.raumgroesse>0){this._mtmFlaeche();this._nav('3');}
        else if(f==='3') this._nav('4-schiene');
        else if(f==='4-abh'&&this.S.abhaengung_cm>0){this._recomp();this._updColors();this._nav('5');}
        else if(f==='4-wand') this._nav('5');
      }));
    }

    _mtmFlaeche() {
      const qm=this.S.raumgroesse;
      if(qm>0) cwMatomoKalk('flaeche_gewaehlt', String(qm), mtmFlaecheKlasse(qm), qm);
    }

    // ── Calculate (Summary → Loading → Gift/Result) ───────────────────────
    _bindCalc() {
      const btn=this.querySelector('[data-action="calculate"]');
      if(!btn) return;
      btn.addEventListener('click',()=>this._runLoading());
    }

    _inputHash() {
      // Farbe nicht im Hash: aendert die Berechnung nicht, nur das Produktbild
      const s=this.S;
      return `${s.branche}|${s.raumgroesse}|${s.deckenhoehe_m}|${s.abhaengung_cm}|${s.montage_typ}`;
    }

    async _runLoading() {
      const s=this.S;
      cwMatomoKalk('berechnet', this._inputHash());
      const parts=[BRANCHE_LBL[s.branche]||s.branche,`${s.raumgroesse} m²`,`${tt('lbl_decke','Deckenhöhe')} ${fmtM(s.deckenhoehe_m)} m`,MONTAGE_LBL[s.montage_typ],COLOR_LBL[s.farbe]];
      const sumEl=this.querySelector('[data-summary-line]');
      if(sumEl) sumEl.textContent=parts.join(' · ');

      // Hash-based skip: if inputs unchanged, skip animation.
      // Das Geschenk kommt als Popup ueber dem Ergebnis (A5), nicht mehr als Zwischenschritt.
      const hash=this._inputHash();
      if(this._lastHash===hash) {
        this._nav('result');
        return;
      }

      const isRecalc = !!this._lastHash;
      this._lastHash=hash;

      const contentEl=this.querySelector('[data-summary-content]');
      const loadingEl=this.querySelector('[data-loading]');

      // Content verstecken, Loading zeigen
      if(contentEl) contentEl.style.display='none';
      if(loadingEl) { loadingEl.hidden=false; loadingEl.style.display='block'; }

      // 2,5 Sek Gesamt, mit kurzen Pausen bei 35% und 70% (simuliert "Verarbeitung")
      const bar=document.getElementById('cwLoadingBar');
      const txt=document.getElementById('cwLoadingText');

      await new Promise(resolve => {
        var progress=0;
        var paused=false;
        var messages=[[0,tt('load_1','Raumgeometrie analysiert...')],[35,tt('load_2','Klangabdeckung berechnet...')],[70,tt('load_3','Frequenzverteilung optimiert...')],[90,tt('load_4','Konfiguration erstellt.')]];
        if(isRecalc) messages=[[0,tt('load_recalc','Wird rekalkuliert...')]];
        var msgIdx=0;
        // 25ms x 100 = 2,5s Basis. Pausen addieren ~300ms extra.
        var stepMs = isRecalc ? 12 : 25;

        if(bar) bar.style.width='0';
        if(txt) txt.textContent=messages[0][1];

        var iv=setInterval(function(){
          if(paused) return;
          progress+=1;
          if(bar) bar.style.width=progress+'%';

          if(msgIdx<messages.length && progress>=messages[msgIdx][0]){
            if(txt) txt.textContent=messages[msgIdx][1];
            msgIdx++;
          }

          // Kurze Pausen bei 35% und 70% (150ms je) - simuliert Verarbeitung
          if(!isRecalc && (progress===35||progress===70)){
            paused=true;
            setTimeout(function(){paused=false;},150);
          }

          if(progress>=100){
            clearInterval(iv);
            resolve();
          }
        }, stepMs);
      });

      // Reset: Loading verstecken, Content zeigen
      if(loadingEl) { loadingEl.style.display='none'; loadingEl.hidden=true; }
      if(contentEl) contentEl.style.display='';
      if(bar) bar.style.width='0';

      this._hasCalced=true;

      // Immer direkt zum Ergebnis - das Geschenk-Gate oeffnet als Popup darueber (A5)
      this._nav('result');
    }

    // ── Colors (Step 5) ───────────────────────────────────────────────────
    _updColors() {
      const p=this.resolveProducts();if(!p)return;
      const hint=this.querySelector('[data-luna-hint]');if(hint)hint.hidden=p.speaker!=='luna-smart';
      const avail=COLOR_AVAIL[p.speaker]||['weiss','schwarz'];
      this.querySelectorAll('[data-field="farbe"] .cw-quiz__option').forEach(b=>{
        const ok=avail.includes(b.dataset.value);b.toggleAttribute('disabled',!ok);b.setAttribute('aria-disabled',String(!ok));
      });
    }

    // ── Gift State Machine ────────────────────────────────────────────────
    // Das Gift-Gate lebt jetzt im Modal [data-modal="gift"] (an <body> gemountet).
    // Alle Gift-Queries laufen deshalb ueber _giftRoot() statt this.
    _giftRoot(){ return this._modal('gift') || this; }

    _setGS(s){this._gs=s;const p=this._giftRoot().querySelector('[data-gift-state]');if(p)p.dataset.giftState=s;this._updBackVis();}

    _bindGiftCards() {
      this._giftRoot().querySelectorAll('.cw-quiz__gift-card').forEach(btn=>{
        btn.addEventListener('click',()=>{
          if(this._gs!=='picking') return;
          const v=btn.dataset.value;
          this.S.giftKat=v;
          btn.closest('[data-field]').querySelectorAll('.cw-quiz__gift-card').forEach(b=>{b.setAttribute('aria-checked',String(b===btn));b.classList.toggle('is-selected',b===btn);});
          this._setGS('revealing');
          // Feste Werte (kein Zufall mehr): Karte A = 5% Rabatt, Karte B = +2 Jahre Garantie
          // (4 statt 2). Der Quiz-Worker (validDiscount >= 5) erzeugt den 5%-Gutscheincode.
          const vals = v==='A'
            ? { rabatt: 5, garZus: 0, garGes: 2 }
            : { rabatt: 0, garZus: 2, garGes: 4 };
          this.S.discPct=vals.rabatt; this.S.garZus=vals.garZus; this.S.garGes=vals.garGes;
          this._saveGiftSession(v,vals.rabatt,vals.garZus);
          this._animReveal(v,vals);
        });
      });
    }

    async _animReveal(kat,vals) {
      // Feste Geschenke (5% ODER +2 Jahre) - KEINE Zufalls-/Roll-Animation mehr, sauber
      // direkt den festen Wert zeigen.
      const numEl=this._giftRoot().querySelector('[data-reveal-number]'),contEl=this._giftRoot().querySelector('[data-reveal-content]');
      const isA = kat === 'A';
      if(numEl){ numEl.classList.remove('is-rolling'); numEl.style.display = isA ? '' : 'none'; numEl.textContent = isA ? (vals.rabatt + '%') : ''; }
      contEl.innerHTML = isA
        ? `<p class="cw-quiz__reveal-main">${esc(tpl(tt('reveal_a','{pct} % Rabatt auf dein gesamtes System'),{pct:vals.rabatt}))}</p>`
        : `<p class="cw-quiz__reveal-hero">${esc(tpl(tt('reveal_b_main','{g} Jahre Herstellergarantie'),{g:vals.garGes}))}</p><p class="cw-quiz__reveal-extra">${esc(tpl(tt('reveal_b_extra','Statt 2 Jahre - die zusätzlichen {j} Jahre schenken wir dir.'),{j:vals.garZus}))}</p><p class="cw-quiz__reveal-note">${esc(tt('reveal_b_note','Zusätzlich zur gesetzlichen Gewährleistung. Reparatur oder Austausch auf unsere Kosten.'))}</p>`;
      this._setGS('revealed');
    }

    _showRevealResult() {
      const s = this.S;
      const numEl = this._giftRoot().querySelector('[data-reveal-number]'), contEl = this._giftRoot().querySelector('[data-reveal-content]');
      const isA = s.giftKat === 'A';
      if(numEl){ numEl.classList.remove('is-rolling'); numEl.style.display = isA ? '' : 'none'; numEl.textContent = isA ? (s.discPct + '%') : ''; }
      if(contEl) contEl.innerHTML = isA
        ? `<p class="cw-quiz__reveal-main">${esc(tpl(tt('reveal_a','{pct} % Rabatt auf dein gesamtes System'),{pct:s.discPct}))}</p>`
        : `<p class="cw-quiz__reveal-hero">${esc(tpl(tt('reveal_b_main','{g} Jahre Herstellergarantie'),{g:s.garGes}))}</p><p class="cw-quiz__reveal-extra">${esc(tpl(tt('reveal_b_extra','Statt 2 Jahre - die zusätzlichen {j} Jahre schenken wir dir.'),{j:s.garZus}))}</p><p class="cw-quiz__reveal-note">${esc(tt('reveal_b_note','Zusätzlich zur gesetzlichen Gewährleistung. Reparatur oder Austausch auf unsere Kosten.'))}</p>`;
    }

    _bindGiftForm() {
      const root=this._giftRoot();
      const form=root.querySelector('[data-gift-form]');if(!form)return;
      const inp=root.querySelector('[data-field="email"]'),err=root.querySelector('[data-email-error]');
      form.addEventListener('submit',e=>{
        e.preventDefault();
        if(this._giftSubmitting) return;
        const email=(inp.value||'').trim();
        if(!validEmail(email)){err.hidden=false;inp.focus();return;}
        err.hidden=true;this.S.email=email;
        this._giftSubmitting=true;
        const btn=form.querySelector('button[type="submit"]');
        const btnTxt=btn?.querySelector('.btn-text')||btn;
        const origTxt=btnTxt?.textContent;
        if(btn){btn.disabled=true;}
        if(btnTxt){btnTxt.textContent=tt('securing','Wird gesichert...');}
        this._markClaim();this._clearGiftSession();
        // Nach dem Sichern: Popup schliessen und Ergebnis mit Geschenk neu rendern
        const done=()=>{this._giftOutcome='angenommen';this._closeMod(this._modal('gift'));this._renderResult();this._resumePendingCart();};
        this._requestGiftCode(email).then(()=>{cwTrack('KalkulatorLead');this._persistGiftData();done();}).catch(done).finally(()=>{this._giftSubmitting=false;if(btn){btn.disabled=false;}if(btnTxt){btnTxt.textContent=origTxt;}});
      });
      inp.addEventListener('input',()=>{if(!err.hidden&&validEmail(inp.value))err.hidden=true;});
      // Schritt 1 -> 2: "Geschenk sichern" blendet das Mail-Formular ein (Zustand 'claim').
      root.querySelector('[data-gift-claim-cta]')?.addEventListener('click',()=>{
        this._setGS('claim');
        setTimeout(()=>{ try{ inp.focus(); }catch(_){} },60);
      });
      // "Ohne Geschenk weiter" -> Sicherheitsfrage (decline-Modal)
      root.querySelector('[data-action="skip-gift"]')?.addEventListener('click',()=>{
        this._closeMod(this._modal('gift'));
        setTimeout(()=>this._openModal(),220);
      });
    }

    // ── Geschenk-Popup (A5) ───────────────────────────────────────────────
    // Das Popup oeffnet erst, wenn der Nutzer ein System in den Warenkorb legen will
    // ("In den Warenkorb" oder "Sofort in anderer Farbe"). Die Aktion wird gemerkt und
    // laeuft weiter, sobald das Geschenk gesichert oder endgueltig abgelehnt ist -
    // so landet die Garantie als Warenkorb-Attribut mit im Auftrag.
    // Ablehnen setzt cw_gift_declined (sessionStorage): verzichtet ist verzichtet.
    // openDelay: wenn vorher ein anderes Modal schliesst (geteilter Backdrop, 200ms Animation).
    _giftGate(resume, openDelay) {
      if(this.dataset.giftEnabled!=='true') return false;
      if(this.S.giftClaimed || this.S.giftDeclined) return false;
      try{ if(sessionStorage.getItem('cw_gift_declined')==='true') return false; }catch(_){}
      if(!this._modal('gift')) return false;
      this._pendingCart=resume;
      this._giftPopupDone=false;
      if(openDelay) setTimeout(()=>this._openGiftPopup(), openDelay);
      else this._openGiftPopup();
      return true;
    }

    // Meta: System ist im Warenkorb angekommen - erst nach erfolgreichem /cart/add.js, nie beim
    // Klick oder bei Fehlern. 1x/Session wie WarenkorbKlick (Dedup ueber cwTrack), damit die
    // Quote Klick -> Erfolg sauber bleibt. bundle = Karte, dest = dieselben Werte wie bei
    // WarenkorbKlick (checkout/cart/combo); "andere Farbe" steckt in quelle.
    // geschenk: Entscheidung im Popup dieses Vorgangs (angenommen/abgelehnt), sonst vorher_entschieden.
    // Die kurze Pause vor dem Redirect gibt dem Custom Pixel Zeit, das Event noch zu senden.
    _trackCartSuccess(bundle, dest, value, numItems, quelle) {
      const geschenk=this._giftOutcome||'vorher_entschieden';
      this._giftOutcome=null;
      cwTrack('WarenkorbErfolgreich',{bundle,dest,value:Math.round(value*100)/100,currency:'EUR',num_items:numItems,quelle,geschenk});
      return new Promise(res=>setTimeout(res,300));
    }

    _resumePendingCart() {
      const fn=this._pendingCart; this._pendingCart=null;
      if(fn) setTimeout(fn, 220); // erst nach der Close-Animation des Popups
    }

    _openGiftPopup() {
      if(this._giftPopupDone || this.S.giftClaimed || this.S.giftDeclined) return;
      if(this._loc!=='result') return; // Ergebnis wurde bereits verlassen
      const m=this._modal('gift'); if(!m) return;
      this._giftPopupDone=true;
      // Einzelnes, festes Geschenk: +2 Jahre Herstellergarantie (4 statt 2). Keine Auswahl,
      // kein Zufall, kein Rabatt. Direkt in den "revealed"-Zustand mit E-Mail-Formular.
      this.S.giftKat='B'; this.S.discPct=0; this.S.garZus=2; this.S.garGes=4;
      this._saveGiftSession('B',0,2);
      this._giftFromSession=false;
      // Schritt 1: Geschenk zeigen + "Geschenk sichern"-Button. Das Mail-Formular
      // kommt erst nach Klick (Zustand 'claim'). Sichtbarkeit steuert das CSS ueber
      // data-gift-state, daher hier KEIN inline display mehr setzen.
      this._setGS('revealed');
      this._showRevealResult();
      this._openMod(m);
      cwTrack('GeschenkPopupAngezeigt');
    }

    // R2-7: Schliessen (X/Esc/Aussenklick) lehnt NICHT sofort ab, sondern fragt
    // state-abhaengig nach. Erst die Bestaetigung im Rueckfrage-Modal ist endgueltig.
    _dismissGiftPopup() {
      this._closeMod(this._modal('gift'));
      setTimeout(()=>this._openDeclineConfirm(),220);
    }

    _openDeclineConfirm() {
      const m=this._modal('decline');
      if(!m){ this._finalizeGiftDecline(); this._giftOutcome='abgelehnt'; this._resumePendingCart(); return; }
      const picked = this._gs!=='picking'; // Karte schon gewaehlt/aufgedeckt?
      const set=(sel,txt)=>{const el=m.querySelector(sel);if(el)el.textContent=txt;};
      if(picked){
        set('[data-decline-title]',tt('decline_b_title','Sicher?'));
        set('[data-decline-text]',tt('decline_b_text','Du verzichtest damit endgültig auf dein Geschenk. Das lässt sich nicht rückgängig machen.'));
        set('[data-decline-primary]',tt('decline_b_primary','Behalten'));
        set('[data-decline-secondary]',tt('decline_b_secondary','Ja, ohne Garantieverlängerung in den Warenkorb legen'));
      } else {
        set('[data-decline-title]',tt('decline_a_title','Warte kurz'));
        set('[data-decline-text]',tt('decline_a_text','Du weißt noch gar nicht, was dein Geschenk ist. Deck es zuerst auf. Wenn du jetzt schließt, ist das endgültig.'));
        set('[data-decline-primary]',tt('decline_a_primary','Geschenk aufdecken'));
        set('[data-decline-secondary]',tt('decline_a_secondary','Trotzdem endgültig ablehnen'));
      }
      this._openMod(m);
    }

    // Endgueltige Ablehnung: Session-Flag setzen ("verzichtet ist verzichtet")
    _finalizeGiftDecline() {
      this.S.giftKat=null; this.S.discPct=null; this.S.discCode=null;
      this.S.garZus=0; this.S.garGes=2;
      this.S.giftDeclined=true;
      this._giftPopupDone=true;
      try{ sessionStorage.removeItem('cw_gift_value'); sessionStorage.setItem('cw_gift_declined','true'); }catch(_){}
      cwTrack('GeschenkAbgelehnt');
    }

    _bindGiftModal() {
      const m=this._modal('gift'); if(!m) return;
      m.querySelectorAll('[data-action="gift-close"]').forEach(b=>b.addEventListener('click',()=>this._dismissGiftPopup()));
      // Opt-out auf Seite 1: fuehrt zur "Sicher?"-Rueckfrage (wie der Skip-Link), nur
      // ohne den Umweg ueber "Geschenk sichern" -> 2 Klicks statt 3. Nudge bleibt erhalten.
      m.querySelector('[data-action="decline-gift"]')?.addEventListener('click',()=>this._dismissGiftPopup());
      // Klick auf die Flaeche ausserhalb des Modal-Inhalts schliesst ebenfalls
      m.addEventListener('click',e=>{ if(e.target===m) this._dismissGiftPopup(); });
      document.addEventListener('keydown',e=>{ if(e.key==='Escape'&&!m.hidden) this._dismissGiftPopup(); });
    }

    async _requestGiftCode(email) {
      const s=this.S;
      const workerUrl = this.dataset.workerUrl || 'https://conowave-quiz-worker.conowave.workers.dev';

      if(workerUrl) {
        try {
          const checkRes = await fetch(workerUrl+'/claim-check', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({ email })
          });
          if(checkRes.ok) {
            const checkData = await checkRes.json();
            if(checkData.claimed) {
              // Email hat schon ein Geschenk - bestehende Werte uebernehmen,
              // Banner-Flag setzen damit User auf Result die Inkonsistenz erklaert bekommt.
              s.discCode = checkData.discount_code;
              s.discPct = checkData.rabatt_prozent;
              s.giftKat = checkData.geschenk_typ;
              s.garZus = checkData.garantie_zusatz_jahre || 0;
              s.garGes = 2 + (checkData.garantie_zusatz_jahre || 0);
              s.giftWasReclaimed = true;
              return;
            }
          }

          const res = await fetch(workerUrl+'/gift-code', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({
              email: email,
              geschenk_typ: s.giftKat,
              rabatt_prozent: s.discPct,
              garantie_zusatz_jahre: s.garZus || 0,
              quiz_data: {
                branche:s.branche, flaeche_qm:s.raumgroesse,
                deckenhoehe_m:s.deckenhoehe_m, abhaengung_cm:s.abhaengung_cm||0,
                installationshoehe_m:Number(s.installH).toFixed(2),
                qm_pro_speaker:Math.round(s.qmps), ohr_hoehe:s.ohrH,
                speaker_typ:this.resolveProducts()?.speaker||'',
                speaker_anzahl:this.calculateSystem().n||1,
                sub_anzahl:this.calculateSystem().sub||1,
                farbe:s.farbe, montage:s.montage_typ
              }
            })
          });

          if(res.ok) {
            const data = await res.json();
            s.discCode = data.discount_code;
            s.discPct = data.rabatt_prozent;
            s.garZus = data.garantie_zusatz_jahre;
            s.garGes = data.gesamte_garantie_jahre;
            return;
          }

          if(res.status===409) {
            // Race-Condition: zwischen check und gift-code wurde ein Claim eingespielt.
            // Genauso behandeln wie ein claim-check-hit: existing values nehmen + Banner.
            const data = await res.json();
            s.discCode = data.existing_code;
            s.discPct = data.rabatt_prozent;
            s.giftKat = data.geschenk_typ;
            s.garZus = data.garantie_zusatz_jahre || 0;
            s.garGes = data.gesamte_garantie_jahre || 2;
            s.giftWasReclaimed = true;
            return;
          }

          console.error('[Quiz Worker]', res.status, await res.text());
        } catch(e) {
          console.error('[Quiz Worker] Fetch failed:', e);
        }
      }

      // Fallback: Lead via Shopify /contact (kein echter Code, kein Worker erreichbar)
      const tags = ['quiz-lead', `branche-${s.branche}`, `geschenk-${s.giftKat}`];
      if(s.giftKat === 'A' && s.discPct) tags.push(`rabatt-${s.discPct}`);
      if(s.giftKat === 'B' && s.garZus)  tags.push(`garantie-${s.garGes}jahre`);
      const body = new URLSearchParams({
        'contact[email]': email,
        'contact[tags]': tags.join(','),
        'contact[body]': `Quiz|Kat:${s.giftKat}|${s.discPct||0}%|+${s.garZus||0}J|${JSON.stringify(s)}`,
        'form_type': 'contact'
      });
      try { await fetch(this.dataset.contactUrl, { method:'POST', body }); } catch(_){}
    }

    // ── Modal Mount + Helper ──────────────────────────────────────────────
    // Modale werden ans <body> verschoben damit position:fixed wirklich
    // viewport-relativ ist. Vorher hingen sie im Custom Element und konnten
    // durch transform/filter/contain auf einem Vorfahren ihren Stacking-Context
    // verlieren - das fuehrte zu unsichtbarem Backdrop.
    _mountModalsToBody() {
      if(this._modalsRoot) return;
      this._modalsRoot = document.createElement('div');
      this._modalsRoot.className = 'cw-modals-root';
      document.body.appendChild(this._modalsRoot);
      this.querySelectorAll('[data-modal]').forEach(m => this._modalsRoot.appendChild(m));

      // Globaler Backdrop direkt am body. Eigene Klasse "cw-bd-overlay" - nirgendwo
      // sonst im Theme-CSS referenziert, also kann nichts ueberschreiben.
      // Alle Styles per setProperty mit "important" gesetzt - schlaegt sogar
      // Theme-CSS mit !important. Default display:none.
      this._globalBackdrop = document.createElement('div');
      this._globalBackdrop.className = 'cw-bd-overlay';
      this._globalBackdrop.setAttribute('aria-hidden', 'true');
      const bs = this._globalBackdrop.style;
      bs.setProperty('display', 'none', 'important');
      bs.setProperty('position', 'fixed', 'important');
      bs.setProperty('top', '0', 'important');
      bs.setProperty('left', '0', 'important');
      bs.setProperty('right', '0', 'important');
      bs.setProperty('bottom', '0', 'important');
      bs.setProperty('width', '100vw', 'important');
      bs.setProperty('height', '100vh', 'important');
      bs.setProperty('z-index', '99998', 'important');
      bs.setProperty('background', 'rgba(0, 0, 0, 0.65)', 'important');
      bs.setProperty('backdrop-filter', 'blur(10px)', 'important');
      bs.setProperty('-webkit-backdrop-filter', 'blur(10px)', 'important');
      bs.setProperty('opacity', '0', 'important');
      bs.setProperty('transition', 'opacity .2s ease', 'important');
      bs.setProperty('pointer-events', 'none', 'important');
      document.body.appendChild(this._globalBackdrop);
    }
    _modal(name) {
      return (this._modalsRoot || this).querySelector('[data-modal="'+name+'"]');
    }
    _openMod(modal) {
      if(!modal) return;
      // 1) Modal selbst: position:fixed mit inset:0, alles inline-forciert.
      modal.hidden = false;
      const ms = modal.style;
      ms.setProperty('position', 'fixed', 'important');
      ms.setProperty('top', '0', 'important');
      ms.setProperty('left', '0', 'important');
      ms.setProperty('right', '0', 'important');
      ms.setProperty('bottom', '0', 'important');
      ms.setProperty('z-index', '99999', 'important');
      ms.setProperty('display', 'flex', 'important');
      ms.setProperty('align-items', 'center', 'important');
      ms.setProperty('justify-content', 'center', 'important');
      ms.setProperty('padding', '20px', 'important');
      ms.setProperty('pointer-events', 'auto', 'important');
      document.body.style.overflow = 'hidden';

      // 2) Internes Modal-Backdrop ausblenden - nutzen den globalen body-level Backdrop.
      const innerBackdrop = modal.querySelector('.cw-quiz__modal-backdrop');
      if (innerBackdrop) innerBackdrop.style.setProperty('display', 'none', 'important');

      // 3) Modal-Content fuer Animation vorbereiten.
      const content = modal.querySelector('.cw-quiz__modal-content');
      if (content) {
        const cs = content.style;
        cs.setProperty('position', 'relative', 'important');
        cs.setProperty('z-index', '2', 'important');
        cs.setProperty('transform', 'scale(.95)', 'important');
        cs.setProperty('opacity', '0', 'important');
        cs.setProperty('transition', 'transform .2s ease, opacity .2s ease', 'important');
      }

      // 4) Globaler Backdrop einblenden.
      const bd = this._globalBackdrop;
      if (bd) {
        bd.style.setProperty('display', 'block', 'important');
        bd.style.setProperty('pointer-events', 'auto', 'important');
      }

      // Force reflow bevor wir die End-Styles setzen.
      void modal.offsetHeight;
      if (bd) void bd.offsetHeight;

      requestAnimationFrame(() => {
        modal.classList.add('is-active');
        if (bd) bd.style.setProperty('opacity', '1', 'important');
        if (content) {
          content.style.setProperty('transform', 'scale(1)', 'important');
          content.style.setProperty('opacity', '1', 'important');
        }
      });
    }

    _closeMod(modal) {
      if(!modal) return;
      modal.classList.remove('is-active');
      document.body.style.overflow = '';

      const content = modal.querySelector('.cw-quiz__modal-content');
      if (content) {
        content.style.setProperty('transform', 'scale(.95)', 'important');
        content.style.setProperty('opacity', '0', 'important');
      }

      const bd = this._globalBackdrop;
      if (bd) {
        bd.style.setProperty('opacity', '0', 'important');
        bd.style.setProperty('pointer-events', 'none', 'important');
      }

      setTimeout(() => {
        modal.hidden = true;
        modal.style.setProperty('display', 'none', 'important');
        if (bd) bd.style.setProperty('display', 'none', 'important');
      }, 200);
    }

    disconnectedCallback() {
      if(this._modalsRoot && this._modalsRoot.parentNode) {
        this._modalsRoot.parentNode.removeChild(this._modalsRoot);
        this._modalsRoot = null;
      }
    }

    // ── Modal: Geschenk-ablehnen-Bestaetigung ─────────────────────────────
    _bindModal() {
      const m = this._modal('decline');
      if(!m) return;
      // Abbrechen (Primaer-Button, Backdrop, Esc) = zurueck ins Geschenk-Popup,
      // nichts geht verloren. Nur der Sekundaer-Button lehnt endgueltig ab (R2-7).
      const cancel = () => {
        this._closeMod(m);
        setTimeout(() => { this._giftPopupDone=false; this._openGiftPopup(); }, 220);
      };
      m.querySelectorAll('[data-action="modal-close"]').forEach(b => b.addEventListener('click', cancel));
      m.querySelector('[data-action="modal-retry"]')?.addEventListener('click', cancel);
      m.querySelector('[data-action="modal-decline"]')?.addEventListener('click', () => {
        this._closeMod(m);
        this._finalizeGiftDecline();
        this._giftOutcome='abgelehnt';
        this._nav('result');
        this._resumePendingCart(); // abgelehnt -> gemerkte Warenkorb-Aktion ohne Geschenk ausfuehren
      });
      document.addEventListener('keydown', e => { if(e.key === 'Escape' && !m.hidden) cancel(); });
    }
    _openModal() { this._openDeclineConfirm(); }

    // ── Compute ───────────────────────────────────────────────────────────
    _recomp() {
      this.S.installH = Math.max(0.1, this.S.deckenhoehe_m - (this.S.abhaengung_cm||0)/100);
      // Luna (Wandmontage): fixe ~40 qm/Speaker, Deckenhoehe/Installationshoehe
      // irrelevant (Wandabstrahlung statt Deckenkegel). Sonst physikbasiert.
      this.S.qmps = (this.S.montage_typ === 'wand') ? 40 : qmProSpeaker(this.S.installH, this.S.branche);
    }

    calculateSystem() {
      this._recomp();
      const raw = this.S.raumgroesse / this.S.qmps;
      const n = roundSpeakers(raw, this.S.installH);
      const sub = this.S.raumgroesse > 200 ? 2 : 1;
      // n<=2: 2 Karten (Base ohne Sub / Premium mit Sub).
      // n>2 : 3 Karten (Test-System als Einstieg / Empfohlen ohne Sub / Premium mit Sub).
      if(n<=2) return { mode:'2-card',n,sub, bundles:{
        base:{sp:1,spk:n,sub:0,vol:0}, premium:{sp:1,spk:n,sub:sub,vol:0}
      }};
      // Test-System: fuer Canto/Stromschiene das Festpreis-Angebot (1 Canto + SMARTplayer,
      // ab n>=5 zusaetzlich 1 Subwoofer). Andere Montagearten behalten den bisherigen Aufbau.
      const rp = this.resolveProducts();
      const isCanto = rp && rp.speaker === 'canto-smart';
      // Das Canto-Starter-Angebot nimmt IMMER den SUB canto (auch bei Fitness, wo sonst der
      // SUB quadro empfohlen wird) - sonst stimmt der Festpreis/Rabattcode nicht. Premium bleibt
      // unberuehrt (Fitness-Logik dort noch in Abstimmung). subOverride greift in _effSub().
      const test = isCanto ? {sp:1,spk:1,sub:(n>=5?1:0),vol:0,subOverride:'sub-canto-smart'} : {sp:1,spk:(n>=5?2:1),sub:0,vol:0};
      return { mode:'3-card',n,sub, bundles:{
        test, empfohlen:{sp:1,spk:n,sub:0,vol:0}, premium:{sp:1,spk:n,sub:sub,vol:0}
      }};
    }

    resolveProducts(){
      const p=PRODUCT_MAP[this.S.montage_typ];
      // B2: Fitnessstudios bekommen den bass-staerkeren SUB quadro empfohlen
      if(p && this.S.branche==='fitness' && p.sub!=='sub-quadro-smart') return {...p, sub:'sub-quadro-smart'};
      return p;
    }
    resolveColor(h){const a=COLOR_AVAIL[h]||['weiss'];return a.includes(this.S.farbe)?this.S.farbe:'weiss';}
    // Effektiver Sub eines Bundles: subOverride (Starter-Angebot) schlaegt die resolveProducts-Empfehlung.
    _effSub(b){ return (b&&b.subOverride) || (this.resolveProducts()||{}).sub; }

    bundleItems(b) {
      const p=this.resolveProducts(),sc=this.resolveColor(p.speaker),subH=this._effSub(b),subc=b.sub>0?this.resolveColor(subH):null;
      const items=[{h:'smartplayer',n:NAMES.smartplayer,c:null,q:b.sp,u:PRICES.smartplayer},{h:p.speaker,n:NAMES[p.speaker],c:sc,q:b.spk,u:PRICES[p.speaker]}];
      if(b.sub>0)items.push({h:subH,n:NAMES[subH],c:subc,q:b.sub,u:PRICES[subH]});
      if(b.vol>0)items.push({h:'volumenregler-premium',n:NAMES['volumenregler-premium'],c:null,q:b.vol,u:PRICES['volumenregler-premium']});
      if(p.speaker==='luna-smart')items.push({h:'wandhalterung-luna',n:NAMES['wandhalterung-luna'],c:null,q:b.spk,u:PRICES['wandhalterung-luna']});
      return items;
    }
    bTotal(b){return this.bundleItems(b).reduce((s,i)=>s+i.u*i.q,0);}
    bDisc(b){return this.bTotal(b)*(1-(this.S.discPct||0)/100);}

    // ── Result ────────────────────────────────────────────────────────────
    _renderResult() {
      const c=this.querySelector('[data-result-container]'),sys=this.calculateSystem(),s=this.S;
      const p=this.resolveProducts(),ac=this.resolveColor(p.speaker);
      // Produktbild wird NACH dem Render async geladen (kein broken icon)
      const spkCount = sys.n||sys.bundles.premium?.spk||1;

      // 1. Headline (branchenabhängig)
      const headline = RESULT_HEADLINE[s.branche]||RESULT_HEADLINE.other;

      // Info-Zeile unter den Karten: nur noch die Abdeckung pro Speaker. Der lange
      // Erklaer-, Kontext- und Cono-Text entfaellt bewusst (reduzierte Ergebnisseite).
      const calcInfo=`<p class="cw-quiz__calc-sub">${esc(tpl(tt('calc_sub','Abdeckung pro Speaker bei deinen Eckdaten: ~{qmps} m²'),{qmps:Math.round(s.qmps)}))}</p>`;
      const giftBlock = this._giftBlock();
      const videoBlock = this._videoBlock(p.speaker);
      const specsBlock = this._specsBlock(p.speaker);

      // Notices
      const fb=(s.farbe==='silber'&&ac!=='silber')?`<div class="cw-quiz__info-note">${esc(tt('note_farbe','Silber ist für dieses System nicht verfügbar – wir haben Weiß gewählt.'))}</div>`:'';
      const cl='';  // Hinweis "Geschenk bei frueherem Besuch erhalten" entfernt (nicht mehr noetig).
      // Reclaim-Banner: User hat eine Mail eingegeben die schon ein Geschenk hat.
      // Statt stillschweigend die existing Werte zu nehmen erklaeren wir es transparent.
      const reclaim = s.giftWasReclaimed ? `<div class="cw-quiz__info-note">${esc(tt('note_reclaim','Diese E-Mail-Adresse hat bereits ein Geschenk eingelöst. Wir haben dein früheres Geschenk hervorgeholt – siehe oben.'))}</div>` : '';
      const con=spkCount>=12?`<div class="cw-quiz__info-note">${tpl(esc(tt('note_big','Für ein System dieser Größe können wir eine individuelle Systemplanung empfehlen. {link}.')),{link:`<a href="#cw-quiz-contact" class="cw-quiz__contact-link" data-scroll-contact>${esc(tt('note_big_link','Kontaktiere uns gerne'))}</a>`})}</div>`:'';


      // R3-1: Kontaktformular ist jetzt ein echtes Shopify-Form im Liquid
      // ([data-contact-native], ausserhalb des Result-Containers). Hier nur die
      // versteckten Quiz-Felder befuellen; Sichtbarkeit steuert CSS (nur result).
      const native=this.querySelector('[data-contact-native]');
      if(native){
        const setCf=(k,v)=>{const i=native.querySelector('[data-cf="'+k+'"]');if(i)i.value=v;};
        setCf('subject',`Quiz-Anfrage: ${BRANCHE_LBL[s.branche]||''}, ${s.raumgroesse}m², ${NAMES[p.speaker]||''}`);
        setCf('branche',s.branche||'');
        setCf('flaeche',`${s.raumgroesse} m²`);
        setCf('decke',`${fmtM(s.deckenhoehe_m)} m`);
        setCf('montage',s.montage_typ||'');
        setCf('farbe',s.farbe||'');
        setCf('speaker',`${spkCount}x ${NAMES[p.speaker]||''}`);
        setCf('sub',`${sys.sub}x ${NAMES[p.sub]||''}`);
        // Anfrage laeuft ueber den ERP-Worker (Team-Mail + Kunden-Kopie via n8n),
        // NICHT ueber Shopifys /contact. Submit abfangen. Nur einmal binden.
        if(!this._inquiryBound){
          this._inquiryBound=true;
          const form=native.querySelector('#CwQuizContact')||native.querySelector('form');
          const url=this.dataset.inquiryUrl;
          if(form && url){
            form.addEventListener('submit',ev=>{
              ev.preventDefault();
              const gv=sel=>{const el=native.querySelector(sel);return el?(el.value||'').trim():'';};
              const email=gv('[name="contact[email]"]');
              if(!email){ form.submit(); return; } // leer -> nativer Pflichtfeld-Hinweis
              const payload={email,message:gv('[name="contact[body]"]'),
                subject:gv('[data-cf="subject"]'),branche:gv('[data-cf="branche"]'),
                flaeche:gv('[data-cf="flaeche"]'),decke:gv('[data-cf="decke"]'),
                montage:gv('[data-cf="montage"]'),farbe:gv('[data-cf="farbe"]'),
                speaker:gv('[data-cf="speaker"]'),sub:gv('[data-cf="sub"]'),hp:gv('[data-cf="hp"]')};
              const btn=form.querySelector('[type="submit"]'); if(btn)btn.disabled=true;
              fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
                .then(r=>{if(!r.ok)throw new Error('http '+r.status);return r.json();})
                .then(()=>{
                  const ok=native.querySelector('[data-contact-ajax-success]');
                  if(ok){ok.hidden=false;try{ok.scrollIntoView({behavior:'smooth',block:'center'});}catch(_){}}
                  if(typeof window.cwMatomo==='function') window.cwMatomo('Kontakt','formular_gesendet','Kalkulator / Anfrage');
                  const b=native.querySelector('[name="contact[body]"]'); if(b)b.value='';
                  const em=native.querySelector('[name="contact[email]"]'); if(em)em.value='';
                })
                .catch(()=>{ if(btn)btn.disabled=false; form.submit(); }); // Fallback: nativer Submit statt verlorener Anfrage
            });
          }
        }
        // Nach erfolgreichem Submit (Redirect zurueck): Bestaetigung in den Blick scrollen
        const succ=native.querySelector('[data-contact-success]');
        if(succ && !this._contactSuccessShown){
          this._contactSuccessShown=true;
          setTimeout(()=>{try{succ.scrollIntoView({behavior:'smooth',block:'center'});}catch(_){}},500);
        }
      }

      // A3: Persistentes, klickbares Konfig-Panel - jede Zeile springt zum Schritt
      const cfgRows=[
        [tt('lbl_branche','Branche'), BRANCHE_LBL[s.branche]||s.branche||'–', '1'],
        [tt('lbl_flaeche','Fläche'), s.raumgroesse>0 ? s.raumgroesse+' m²' : '–', '2'],
        [tt('lbl_decke','Deckenhöhe'), fmtM(s.deckenhoehe_m)+' m', '3'],
        [tt('lbl_montage','Montage'), MONTAGE_LBL[s.montage_typ]||s.montage_typ||'–', '4-schiene'],
        [tt('lbl_farbe','Farbe'), COLOR_LBL[s.farbe]||s.farbe||'–', '5']
      ];
      const cfgPanel=`<div class="cw-quiz__result-config" data-result-config>
        <div class="cw-quiz__result-config-head">
          <p class="cw-quiz__result-config-title">${esc(tt('summary_title','Deine Angaben'))}</p>
          <button type="button" class="cw-quiz__result-config-adjust" data-action="restart"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>${esc(tt('adjust_short','Anpassen'))}</button>
        </div>
        <div class="cw-quiz__result-config-rows">${cfgRows.map(r=>`<button type="button" class="cw-quiz__result-config-row" data-goto="${r[2]}" title="${esc(tpl(tt('change_title','{label} ändern'),{label:r[0]}))}"><span class="cw-quiz__result-config-key">${esc(r[0])}</span><span class="cw-quiz__result-config-val">${esc(String(r[1]))}</span><svg class="cw-quiz__result-config-edit" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg></button>`).join('')}</div>
      </div>`;

      c.innerHTML=`
        <div class="cw-quiz__r-grid">
          <section class="cw-quiz__r-headline" data-r="headline">
            <h1 class="cw-quiz__result-headline">${esc(headline)}</h1>
          </section>
          ${(giftBlock || cl) ? `<section class="cw-quiz__r-gift" data-r="gift">${giftBlock || cl}</section>` : ''}
          ${fb ? `<section class="cw-quiz__r-fb" data-r="fb">${fb}</section>` : ''}
          ${reclaim ? `<section class="cw-quiz__r-reclaim" data-r="reclaim">${reclaim}</section>` : ''}
          ${(s.discCode && s.giftKat==='A') ? `<section class="cw-quiz__r-hint" data-r="hint"><p class="cw-quiz__discount-hint">${tpl(esc(tt('discount_hint','Dein Rabattcode: <strong>{code}</strong> – 7 Tage gültig, wird im Checkout automatisch angewendet.')).replace(/&lt;(\/?strong)&gt;/g,'<$1>'),{code:esc(s.discCode)})}</p></section>` : ''}
          ${con ? `<section class="cw-quiz__r-con" data-r="con">${con}</section>` : ''}
          <section class="cw-quiz__r-bundles" data-r="bundles">
            <div class="cw-quiz__bundles" data-mode="${sys.mode}">${this._renderBundles(sys)}</div>
          </section>
          <section class="cw-quiz__r-quote" data-r="quote">${this._quoteBlock()}</section>
          <section class="cw-quiz__r-ask" data-r="ask">${this._askWidget()}</section>
          <section class="cw-quiz__r-refs" data-r="refs">${this._refsBlock()}</section>
          <section class="cw-quiz__r-config" data-r="config">
            ${cfgPanel}
          </section>
          <section class="cw-quiz__r-calc" data-r="calc">
            ${calcInfo}
          </section>
          ${videoBlock ? `<section class="cw-quiz__r-video" data-r="video">${videoBlock}</section>` : ''}
          ${specsBlock ? `<section class="cw-quiz__r-specs" data-r="specs">${specsBlock}</section>` : ''}
        </div>
      `;
      this._bindResultAct(c);
      this._loadSpeakerHero(p.speaker);
      // Meta-Pixel: Ergebnis ist jetzt im DOM (nicht schon beim Klick). Dedupe pro Session.
      // value = empfohlener Systempreis netto (bei 2-Card das Komplett-Bundle) fuer Value-Optimierung.
      cwTrack('KalkulatorErgebnis', { value: Math.round(this.bTotal(sys.bundles.premium)), currency: 'EUR' });
      // Bestands-Awareness: Karten nachtraeglich anreichern (nicht blockierend, fail-safe).
      this._decorateAvail().catch(()=>{});
      this._loadFaq();
      this._loadRefs();
    }

    // Mobile-Ergebnis: FAQ der Startseite einmalig nachladen und unter dem Kontaktformular
    // einsetzen. Die Section-ID im Theme hat einen theme-abhaengigen Praefix
    // (template--<Zahl>__faq_...), daher Startseite laden und per ID-Endung suchen.
    // Nur < 840px (Desktop bleibt unveraendert); fail-safe: bei Fehler bleibt der Block leer.
    _loadFaq() {
      const box=this.querySelector('[data-quiz-faq]');
      if(!box || this._faqState) return;
      const mq=window.matchMedia('(max-width: 839px)');
      if(!mq.matches){
        if(!this._faqMqBound && mq.addEventListener){ this._faqMqBound=true; mq.addEventListener('change',()=>{ if(mq.matches) this._loadFaq(); }); }
        return;
      }
      this._faqState='loading';
      const id=box.dataset.faqId;
      fetch(box.dataset.faqSrc||'/',{credentials:'same-origin'})
        .then(r=>{if(!r.ok)throw new Error('http '+r.status);return r.text();})
        .then(html=>{
          this._faqState='done';
          const doc=new DOMParser().parseFromString(html,'text/html');
          const sec=[...doc.querySelectorAll('[id^="shopify-section-"]')].find(el=>el.id.endsWith('__'+id)||el.id==='shopify-section-'+id);
          if(!sec || !sec.querySelector('.faq')) return;
          sec.querySelectorAll('script').forEach(el=>el.remove()); // kein doppeltes FAQPage-JSON-LD der Startseite
          box.appendChild(document.importNode(sec,true));
        })
        .catch(()=>{ this._faqState=null; });
    }

    // "Produktseite" des empfohlenen Speakers direkt im Ergebnis: Bild + Beschreibung +
    // technische Daten aus den Produkt-Metafeldern (<template data-spk-desc/-specs>, vom
    // Liquid injiziert). Alle Links werden entfernt - niemand wird herausgefuehrt.
    _specsBlock(handle){
      // Produktbeschreibung (body_html) + technische Daten (rich_text-JSON) aus den
      // <template>s. Links werden entfernt. Dazu Trust-Badges + Testimonial (Kundenstimme).
      const grab=(sel,rt)=>{const t=this.querySelector(sel);if(!t)return{html:'',sub:''};const d=document.createElement('div');d.appendChild(t.content.cloneNode(true));if(rt)d.querySelectorAll('script.cw-rt').forEach(sc=>{const b=document.createElement('div');b.innerHTML=richTextToHtml(sc.textContent);sc.replaceWith(b);});d.querySelectorAll('a').forEach(a=>a.replaceWith(...a.childNodes));return{html:d.innerHTML.trim(),sub:t.dataset.sub||''};};
      const dd=grab(`template[data-spk-desc="${handle}"]`,false);
      const ss=grab(`template[data-spk-specs="${handle}"]`,true);
      if(!dd.html&&!ss.html)return'';
      return `<div class="cw-quiz__specs-top">
          <div class="cw-quiz__specs-media"><div class="cw-quiz__speaker-hero" data-speaker-hero></div></div>
          <div class="cw-quiz__specs-copy">
            <p class="cw-quiz__specs-eyebrow">${esc(tt('specs_eyebrow','Dein Speaker im Detail'))}</p>
            <h2 class="cw-quiz__specs-title">${esc(NAMES[handle]||'')}</h2>
            ${ss.sub?`<p class="cw-quiz__specs-sub">${esc(ss.sub)}</p>`:''}
            ${dd.html?`<div class="cw-quiz__specs-desc">${dd.html}</div>`:''}
          </div>
        </div>
        ${ss.html?`<div class="cw-quiz__specs-tech">${ss.html}</div>`:''}
        ${this._trustHtml()}`;
    }

    // "Noch Fragen"-Widget: Desktop als Button+Feld unter den Karten, mobil als Overlay-Button
    // unten rechts, der zum Eingabefeld aufklappt. Sendet an den Inquiry-Endpoint (wie das
    // Kontaktformular) mit den Quiz-Eckdaten.
    _askWidget(){
      const s=this.S,p=this.resolveProducts(),sys=this.calculateSystem(),spk=sys.n||1;
      const rows=[
        [tt('lbl_branche','Branche'), BRANCHE_LBL[s.branche]||s.branche||'–'],
        [tt('lbl_flaeche','Fläche'), s.raumgroesse>0 ? s.raumgroesse+' m²' : '–'],
        [tt('lbl_decke','Deckenhöhe'), fmtM(s.deckenhoehe_m)+' m'],
        [tt('lbl_montage','Montage'), MONTAGE_LBL[s.montage_typ]||s.montage_typ||'–'],
        [tt('lbl_farbe','Farbe'), COLOR_LBL[s.farbe]||s.farbe||'–'],
        [tt('ask_system','Empfohlenes System'), `${spk}× ${NAMES[p.speaker]||''}${sys.sub>0?` + ${sys.sub}× ${NAMES[p.sub]||''}`:''}`]
      ];
      const summary=rows.map(r=>`<div class="cw-quiz__ask-sumrow"><span class="cw-quiz__ask-sumk">${esc(r[0])}</span><span class="cw-quiz__ask-sumv">${esc(String(r[1]))}</span></div>`).join('');
      return `<div class="cw-quiz__ask-box">
          <h3 class="cw-quiz__ask-h">${esc(tt('ask_title','Noch Fragen? Werktags antworten wir dir meist innerhalb weniger Minuten.'))}</h3>
          <p class="cw-quiz__ask-p">${esc(tt('ask_sub','Wir beantworten dir alles persönlich - ganz ohne Verpflichtung.'))}</p>
          <div class="cw-quiz__ask-cols">
            <div class="cw-quiz__ask-summary">${summary}</div>
            <div class="cw-quiz__ask-form">
              <div class="cw-quiz__ask-names">
                <input type="text" class="cw-quiz__ask-in" data-ask-firstname placeholder="${esc(tt('ask_first_ph','Vorname'))}" autocomplete="given-name">
                <input type="text" class="cw-quiz__ask-in" data-ask-lastname placeholder="${esc(tt('ask_last_ph','Nachname'))}" autocomplete="family-name">
              </div>
              <input type="email" class="cw-quiz__ask-email" data-ask-email placeholder="${esc(tt('ask_email_ph','Deine E-Mail'))}" autocomplete="email">
              <input type="tel" class="cw-quiz__ask-in" data-ask-phone placeholder="${esc(tt('ask_phone_ph','Telefon (optional)'))}" autocomplete="tel">
              <textarea class="cw-quiz__ask-msg" data-ask-msg rows="3" placeholder="${esc(tt('ask_msg_ph','Deine Frage (optional)'))}"></textarea>
              <button type="button" class="cw-quiz__ask-send" data-ask-send>${esc(tt('ask_send','Frage senden'))}</button>
              <p class="cw-quiz__ask-hint" data-ask-hint></p>
            </div>
          </div>
        </div>`;
    }

    async _sendAsk(root){
      const emailEl=root.querySelector('[data-ask-email]'),msgEl=root.querySelector('[data-ask-msg]'),btn=root.querySelector('[data-ask-send]'),hint=root.querySelector('[data-ask-hint]');
      const fnEl=root.querySelector('[data-ask-firstname]'),lnEl=root.querySelector('[data-ask-lastname]'),phEl=root.querySelector('[data-ask-phone]');
      const email=(emailEl.value||'').trim();
      if(!validEmail(email)){ hint.textContent=tt('ask_err_email','Bitte gültige E-Mail eingeben.'); try{emailEl.focus();}catch(_){} return; }
      const url=this.dataset.inquiryUrl; if(!url){ hint.textContent=tt('ask_err','Konnte nicht senden - bitte später erneut.'); return; }
      const s=this.S,p=this.resolveProducts(),sys=this.calculateSystem(),spk=sys.n||1;
      const payload={ email, message:(msgEl.value||'').trim(),
        firstName:((fnEl&&fnEl.value)||'').trim(), lastName:((lnEl&&lnEl.value)||'').trim(), phone:((phEl&&phEl.value)||'').trim(), quelle:'noch-fragen',
        subject:`Quiz-Frage: ${BRANCHE_LBL[s.branche]||''}, ${s.raumgroesse}m²`,
        branche:s.branche||'', flaeche:`${s.raumgroesse} m²`, decke:`${fmtM(s.deckenhoehe_m)} m`,
        montage:s.montage_typ||'', farbe:s.farbe||'', speaker:`${spk}x ${NAMES[p.speaker]||''}`,
        sub:`${sys.sub}x ${NAMES[p.sub]||''}`, hp:'',
        quiz_data:{ branche:s.branche||'', flaeche_qm:s.raumgroesse, deckenhoehe_m:s.deckenhoehe_m, montage:s.montage_typ||'', farbe:s.farbe||'', speaker_anzahl:spk, speaker_typ:p.speaker||'', sub_anzahl:sys.sub, sub_typ:(sys.sub>0?(p.sub||''):'') } };
      const orig=btn.textContent; btn.disabled=true; btn.textContent=tt('ask_sending','Wird gesendet…'); hint.textContent='';
      try{
        const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
        if(!r.ok) throw new Error('http '+r.status);
        btn.textContent=tt('ask_sent','Gesendet ✓'); msgEl.value='';
        if(typeof window.cwMatomo==='function') window.cwMatomo('Kontakt','formular_gesendet','Kalkulator / Frage');
        hint.textContent=tt('ask_ok','Danke! Wir melden uns in unter 24 Stunden.');
      }catch(e){ btn.disabled=false; btn.textContent=orig||tt('ask_send','Frage senden'); hint.textContent=tt('ask_err','Konnte nicht senden - bitte später erneut.'); }
    }

    // Referenzen-Block: branchen-passende Projekte (Bild-Kacheln) + inCB-Statement darunter.
    _refsBlock(){
      return `<div class="cw-quiz__refs" data-quiz-refs hidden>
          <h2 class="cw-quiz__refs-title">${esc(tt('refs_title','Referenzen aus der Praxis'))}</h2>
          <div class="cw-quiz__refs-grid" data-refs-grid></div>
        </div>`;
    }

    // inCB-Kundenstimme als eigener Block (zwischen System-Cards und "Noch Fragen").
    _quoteBlock(){
      const refT=this.querySelector('template[data-quiz-ref]');
      const ref=refT?(()=>{const d=document.createElement('div');d.appendChild(refT.content.cloneNode(true));return d.innerHTML.trim();})():'';
      return ref?`<div class="cw-quiz__r-quote-inner">${ref}</div>`:'';
    }

    // Projekt-Metaobjekte (Referenzen) aus dem mapdata-JSON laden und branchen-passend
    // als Bild-Kacheln zeigen. Branche-Matching per Alias (Projekt-Branchen sind Freitext);
    // kein Treffer -> Flagships/erste als allgemeiner Fallback. Rows werden gecacht. Fail-safe.
    _loadRefs(){
      const grid=this.querySelector('[data-refs-grid]'); if(!grid) return;
      // Kuratierte "spannende" Marken je Quiz-Branche - Match nach NAME (flagship-Flag bewusst
      // nicht genutzt: zu breit/unpassend). Cafe & Hotel haben eigene Logik (unten).
      const FEAT={
        retail:['westwing','karl lagerfeld','hugo boss','new balance','brax','strellson','bulthaup','boconcept','sportscheck','bmw','fielmann','mister spex','mr spex','puma','g-star','ktm','mercedes','mango'],
        fitness:['mcfit','sportland'],
        hotel:['hilton','hyatt','andaz','meridien','crowne plaza','voco','renaissance','quellenhof','la maiena','my arbor','savoy'],
        beauty:['pompadour','apotheke'],
        other:['allianz arena','bmw','red bull','world economic forum','wef','therme meran','edinburgh gin','cupra','salewa','infineon','e.on','hapag','bikini berlin','kadewe','ikea','breuninger','globus']
      };
      // Branchen-Label als Auffuell-Fallback.
      const AL={
        retail:['store','einzelhandel','retail','fashion','mode','boutique'],
        fitness:['fitness','gym','studio'],
        beauty:['beauty','friseur','kosmetik','salon'],
        other:['sonstiges','office']
      };
      const norm=v=>String(v||'').toLowerCase();
      const shuf=a=>{for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t;}return a;};
      const render=rows=>{
        const b=this.S.branche;
        const nm=x=>norm(x.name);
        const nameHit=(x,list)=>list.some(k=>nm(x).indexOf(k)>=0);
        const branchHit=(x,list)=>list.some(k=>norm(x.branch).indexOf(k)>=0);
        const used=[];
        const add=cand=>{shuf(cand.slice()).forEach(x=>{if(used.indexOf(x)<0&&used.length<3)used.push(x);});};
        const addOne=cand=>{const s=shuf(cand.slice());if(s.length)add([s[0]]);};
        if(b==='cafe'){
          // Gastronomie ohne Fastfood (Burger King raus), gehobene (AlpiNN & Co.) bevorzugt.
          const gastro=x=>branchHit(x,['gastro','restaurant','cafe','café','bar','bistro'])&&nm(x).indexOf('burger king')<0;
          const CAFE=['café','cafe','le bol','baguette','bäck','baeck','kantini','bistro'];
          const REST=['restaurant','gasthaus','bräu','braeu','pub','alpinn','castel herrnhof','bohne und malz','comera','weingut','skilounge','merkur'];
          addOne(rows.filter(x=>gastro(x)&&nameHit(x,CAFE)));  // immer 1 Cafe
          addOne(rows.filter(x=>gastro(x)&&nameHit(x,REST)));  // immer 1 Restaurant
          add(rows.filter(x=>gastro(x)));                      // 3. + Auffuellen (kein Fastfood)
        } else if(b==='hotel'){
          addOne(rows.filter(x=>nm(x).indexOf('quellenhof')>=0));  // immer Quellenhof
          addOne(rows.filter(x=>nm(x).indexOf('andaz')>=0));       // immer Andaz
          add(rows.filter(x=>nameHit(x,FEAT.hotel)));              // 3. weiteres cooles Hotel
          add(rows.filter(x=>branchHit(x,['hotel'])));             // Auffuellen
        } else {
          const feat=FEAT[b]||[], al=AL[b]||[];
          add(rows.filter(x=>nameHit(x,feat)));                              // kuratierte spannende Marken
          if(used.length<3) add(rows.filter(x=>al.length&&branchHit(x,al))); // Branchen-Label
          if(used.length<3) add(rows);                                       // sonst irgendwelche
        }
        const picked=used.slice(0,3);
        if(!picked.length) return;
        // Kacheln NICHT klickbar (div statt a) - sonst verlaesst man die Kalkulatorseite.
        grid.innerHTML=picked.map(m=>`<div class="cw-quiz__ref-tile">
            <span class="cw-quiz__ref-tile-img"><img src="${esc(m.img)}" alt="${esc(m.name)}" loading="lazy"></span>
            ${m.branch?`<span class="cw-quiz__ref-tile-branch">${esc(m.branch)}</span>`:''}
            <span class="cw-quiz__ref-tile-name">${esc(m.name)}</span>
            ${m.city?`<span class="cw-quiz__ref-tile-city">${esc(m.city)}</span>`:''}
          </div>`).join('');
        const box=this.querySelector('[data-quiz-refs]'); if(box) box.hidden=false;
      };
      if(this._refsRows){ render(this._refsRows); return; }
      // Bevorzugt Inline-JSON aus der Section (kein Fetch -> auch in der Preview sicher).
      const inl=this.querySelector('[data-quiz-refs-data]');
      if(inl){ try{ const rows=JSON.parse(inl.textContent||'[]'); if(Array.isArray(rows)){ this._refsRows=rows.filter(m=>m&&m.img&&m.name); render(this._refsRows); return; } }catch(e){} }
      fetch(this.dataset.refsUrl||'/pages/map?view=mapdata&page=1',{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(r=>{if(!r.ok)throw 0;return r.json();})
        .then(rows=>{ if(!Array.isArray(rows))return; this._refsRows=rows.filter(m=>m&&m.img&&m.name); render(this._refsRows); })
        .catch(()=>{});
    }

    // Installations-Video - nur wenn ein Canto empfohlen wird (Stromschiene) und im
    // Theme-Editor eine Video-URL hinterlegt ist (<template data-install-video>).
    _videoBlock(handle){
      if(handle!=='canto-smart')return'';
      const t=this.querySelector('template[data-install-video]');if(!t)return'';
      const d=document.createElement('div');d.appendChild(t.content.cloneNode(true));
      if(!d.querySelector('iframe, video'))return'';
      return `<p class="cw-quiz__video-title">${esc(tt('video_title','So einfach ist die Installation'))}</p><div class="cw-quiz__video-embed">${d.innerHTML.trim()}</div>`;
    }

    // Trust-Elemente des empfohlenen Speakers (<template data-spk-trust>, Quelle wie Produktseite).
    _trustHtml(){
      // Feste Trust-Badges (nicht mehr aus dem Produkt-Icon-Metafeld).
      const ic='width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
      const items=[
        [`<svg ${ic}><path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-3"/></svg>`, tt('trust_return','14 Tage Rückgaberecht')],
        [`<svg ${ic}><path d="M12 3 5 6v5c0 4.4 3 7.4 7 8.9 4-1.5 7-4.5 7-8.9V6l-7-3Z"/><path d="M9.2 12.2 11 14l3.8-4"/></svg>`, tt('trust_warranty','2 Jahre Garantie')],
        [`<svg ${ic}><circle cx="12" cy="12" r="9"/><path d="M8.2 12.2 11 15l5-6"/></svg>`, tt('trust_installs','+37.000 Installationen')]
      ];
      return `<div class="cw-quiz__trust"><ul class="cw-quiz__trust-list">${items.map(it=>`<li class="cw-quiz__trust-item">${it[0]}<span>${esc(it[1])}</span></li>`).join('')}</ul></div>`;
    }

    _giftBlock(){
      const s=this.S;
      if(!s.giftKat) return '';
      if(s.giftKat==='A'){
        if(!s.discPct) return '';
        return `<div class="cw-quiz__gift-block">
          <p class="cw-quiz__gift-block-label">${esc(tt('gb_label','Dein Geschenk'))}</p>
          <p class="cw-quiz__gift-block-value">${s.discPct}%</p>
          <p class="cw-quiz__gift-block-desc">${esc(tt('gb_a_desc','Rabatt auf dein System'))}</p>
          <p class="cw-quiz__gift-block-meta">${esc(tt('gb_a_meta','Wird automatisch im Checkout angewendet · Nur 7 Tage gültig'))}</p>
        </div>`;
      }
      // Karte B: nur Garantie
      if(!s.garZus) return '';
      return `<div class="cw-quiz__gift-block">
        <p class="cw-quiz__gift-block-label">${esc(tt('gb_label','Dein Geschenk'))}</p>
        <p class="cw-quiz__gift-block-value">${esc(tpl(tt('gb_b_value','+{j} Jahre Garantie'),{j:s.garZus}))}</p>
        <p class="cw-quiz__gift-block-desc">${esc(tpl(tt('gb_b_desc','Gesamt {g} Jahre statt 2'),{g:s.garGes}))}</p>
        <p class="cw-quiz__gift-block-meta">${esc(tt('gb_b_meta','Garantie wird in deinem Kundenkonto vermerkt'))}</p>
      </div>`;
    }

    _renderBundles(sys) {
      const mk=(k,b,o)=>this._card(k,b,o);
      // Frequenz je Karte: ohne Sub = Speaker-Range, mit Sub = ab 37 Hz bis zur oberen Grenze.
      const sp=this.resolveProducts().speaker, hzSpk=SPK_HZ[sp]||'105 - 21.000 Hz', hzSub=SUB_HZ_LOW+' - '+hzSpk.split(' - ')[1];
      // Festpreis-Angebot nur beim Canto (siehe TEST_OFFER); sonst normaler berechneter Preis.
      const testOffer = sp==='canto-smart' ? (sys.n>=5 ? TEST_OFFER.big : TEST_OFFER.small) : null;
      const bt={base:tt('b_base_t','Base'),base_s:tt('b_base_s','Ohne Subwoofer'),test:tt('b_test_t','Test-System'),test_s:tt('b_test_s','Klein beginnen'),empf:tt('b_empf_t','Empfohlen'),empf_s:tt('b_empf_s','Ohne Subwoofer'),prem:tt('b_prem_t','Premium'),prem_s:tt('b_prem_s','Mit Subwoofer')};
      if(sys.mode==='2-card') return [mk('base',sys.bundles.base,{t:bt.base,s:bt.base_s,f:false,h:BUNDLE_COPY.base,freq:hzSpk}),mk('premium',sys.bundles.premium,{t:bt.prem,s:bt.prem_s,f:false,h:BUNDLE_COPY.premium,freq:hzSub})].join('');
      return [mk('test',sys.bundles.test,{t:bt.test,s:bt.test_s,f:false,h:this._testCopy(sys.bundles.test),offer:testOffer}),mk('empfohlen',sys.bundles.empfohlen,{t:bt.empf,s:bt.empf_s,f:true,h:BUNDLE_COPY.empfohlen,freq:hzSpk}),mk('premium',sys.bundles.premium,{t:bt.prem,s:bt.prem_s,f:false,h:BUNDLE_COPY.premium,freq:hzSub})].join('');
    }

    // Beschreibung der Test-System-Karte - variabel nach echtem Test-Bundle: realer Speaker-Name,
    // Anzahl (1x/2x) und ob ein Subwoofer dabei ist (Canto ab n>=5). Ersetzt den fruehren Fixtext.
    _testCopy(b){
      const p=this.resolveProducts();
      const base=((p&&p.speaker)||'').replace('-smart','');
      const spk=base?base.charAt(0).toUpperCase()+base.slice(1):tt('copy_test_spk_fb','Speaker');
      const n=(b&&b.spk)||1;
      const intro=tt('copy_test_intro','Du willst erstmal testen und in deinem wichtigsten Bereich beginnen.');
      const tail=(b&&b.sub>0)
        ? tpl(tt('copy_test_sub','Dann starte mit {n}x {spk} und einem Subwoofer und überzeug dich.'),{n,spk})
        : tpl(tt('copy_test_nosub','Dann starte erstmal nur mit {n}x {spk} und überzeug dich.'),{n,spk});
      return intro+' '+tail;
    }

    _card(key,bundle,o) {
      const items=this.bundleItems(bundle),raw=this.bTotal(bundle),disc=this.bDisc(bundle),pct=this.S.discPct;

      const rows=items.map(i=>{
        const lbl=i.c?`${i.q}× ${esc(i.n)} (${esc(COLOR_LBL[i.c])})`:`${i.q}× ${esc(i.n)}`;
        const info=PRODUCT_INFO[i.h]||'';
        const tip=info?`<span class="cw-quiz__info-tip" data-tip="${esc(info)}" tabindex="0" aria-label="${esc(tt('info_aria','Info'))}"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" stroke="currentColor"/><path d="M8 7v4M8 5.5v.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></span>`:'';
        return `<li data-av-h="${esc(i.h)}"${i.c?` data-av-c="${esc(i.c)}"`:''}><span class="cw-quiz__bundle-item-name">${lbl}${tip}</span></li>`;
      }).join('');

      const noSub=bundle.sub===0?`<li><span class="cw-quiz__bundle-item-name cw-quiz__bundle-item-name--empty">${esc(tt('b_nosub','kein Subwoofer'))}</span></li>`:'';

      let priceStr;
      if(o.offer){
        // Starter-Angebot (Test-System/Canto): Festpreis gross, regulaerer Preis durchgestrichen (ohne "Du sparst").
        priceStr=`<p class="cw-quiz__bundle-offer-label">${esc(tt('b_offer_label','Starter Angebot'))}</p>
          <p class="cw-quiz__bundle-price-line">${esc(tpl(tt('b_price','Systempreis: {price} zzgl. MwSt'),{price:fmtEur(o.offer)}))}</p>
          ${raw>o.offer?`<p class="cw-quiz__bundle-price-ref"><span class="cw-quiz__bundle-price-regular">${esc(tpl(tt('b_regular','Regulär: {price}'),{price:fmtEur(raw)}))}</span></p>`:''}`;
      } else if(pct){
        const savings=raw-disc;
        priceStr=`<p class="cw-quiz__bundle-price-line">${esc(tpl(tt('b_price','Systempreis: {price} zzgl. MwSt'),{price:fmtEur(disc)}))}</p>
          <p class="cw-quiz__bundle-price-ref"><span class="cw-quiz__bundle-price-regular">${esc(tpl(tt('b_regular','Regulär: {price}'),{price:fmtEur(raw)}))}</span> – <span class="cw-quiz__bundle-price-savings">${esc(tpl(tt('b_savings','Du sparst {price}'),{price:fmtEur(savings)}))}</span></p>`;
      } else {
        priceStr=`<p class="cw-quiz__bundle-price-line">${esc(tpl(tt('b_price','Systempreis: {price} zzgl. MwSt'),{price:fmtEur(raw)}))}</p>`;
      }

      const hasGift=!!this.S.giftKat;
      // B3: einheitlicher Warenkorb-CTA (Installateur-Vermittlung entfernt)
      const ctaLbl=hasGift?tt('cta_gift','Geschenk einlösen – in den Warenkorb'):tt('cta_cart','In den Warenkorb');
      // Mail-Hint: bei A "Rabattcode gebunden", bei B "Garantie gebunden"
      const unesc=(x)=>x.replace(/&lt;(\/?strong)&gt;/g,'<$1>');
      const mailH = (hasGift && this.S.email)
        ? (this.S.giftKat === 'A'
            ? `<p class="cw-quiz__bundle-mail-hint">${tpl(unesc(esc(tt('b_mail_a','Rabattcode an <strong>{email}</strong> gebunden.'))),{email:esc(this.S.email)})}</p>`
            : `<p class="cw-quiz__bundle-mail-hint">${tpl(unesc(esc(tt('b_mail_b','Garantie an <strong>{email}</strong> gebunden.'))),{email:esc(this.S.email)})}</p>`)
        : '';
      // Hinweis-Bubble ("Empfohlen") entfernt - die Empfohlen-Karte bleibt nur dezent hervorgehoben.

      // Karten-Klappbarkeit: Auf Mobile ist nur Premium zugeklappt,
      // Starter und Empfohlen sind offen. Auf Desktop ignoriert das CSS den collapsed-Zustand.
      const collapsible = (key === 'premium');
      const cardClass = 'cw-quiz__bundle'
        + (o.f ? ' cw-quiz__bundle--featured' : '')
        + (collapsible ? ' cw-quiz__bundle--collapsible cw-quiz__bundle--collapsed' : '');

      return `<article class="${cardClass}" data-bundle-key="${key}">
        <div class="cw-quiz__bundle-header" data-bundle-toggle>
          <h3 class="cw-quiz__bundle-title">${esc(o.t)}</h3>
          <p class="cw-quiz__bundle-subtitle">${esc(o.s)}</p>
          <p class="cw-quiz__bundle-hint">${esc(o.h)}</p>
          ${o.freq?`<p class="cw-quiz__bundle-freq">${esc(tpl(tt('b_freq','Frequenzbereich: {hz}'),{hz:o.freq}))}</p>`:''}
          ${collapsible ? '<span class="cw-quiz__bundle-chevron" aria-hidden="true">+</span>' : ''}
        </div>
        <div class="cw-quiz__bundle-body">
        <ul class="cw-quiz__bundle-items">${rows}${noSub}</ul>
        <div class="cw-quiz__bundle-total">${priceStr}</div>
        <button type="button" class="cw-quiz__bundle-save" data-bundle-savecfg="${key}">${esc(tt('b_save','System per Mail schicken'))}</button>
        <p class="cw-quiz__bundle-save-hint"></p>
        <button type="button" class="cw-quiz__bundle-cta" data-bundle-cta="${key}">${esc(ctaLbl)}</button>
        ${this._trustHtml()}
        ${mailH}
        </div>
      </article>`;
    }

    _instInfo(){const t=INSTALL_TXT[this.S.montage_typ]||INSTALL_TXT.aufbau_candela;return `<div class="cw-quiz__install-info"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><p><strong>${esc(t.t)}</strong> – ${esc(t.s)}</p></div>`;}
    _brImg(){
      const map={cafe:1,retail:2,fitness:3,hotel:4,beauty:5,other:6};
      const num = map[this.S.branche]||6;
      // data-branche-image-1 wird zu dataset['brancheImage-1'] (Zahl nach Bindestrich bleibt)
      const url = this.getAttribute('data-branche-image-'+num);
      if(!url || url.length < 5) return '';
      return `<div class="cw-quiz__branche-image"><img src="${url}" alt="${BRANCHE_LBL[this.S.branche]||''}" loading="lazy"></div>`;
    }

    _bindResultAct(c) {
      c.querySelectorAll('[data-bundle-cta]').forEach(b=>b.addEventListener('click',()=>this._addToCart(b.dataset.bundleCta,b,'checkout')));
      c.querySelectorAll('[data-bundle-savecfg]').forEach(b=>b.addEventListener('click',()=>this._saveConfig(b.dataset.bundleSavecfg,b)));
      c.querySelectorAll('[data-bundle-cart]').forEach(b=>b.addEventListener('click',()=>this._addToCart(b.dataset.bundleCart,b,'cart')));
      c.querySelector('[data-action="restart"]')?.addEventListener('click',()=>this._restart());
      // "Noch Fragen"-Widget: Toggle (Button/FAB + Schliessen) auf/zu, E-Mail vorbefuellen, Senden.
      const ask=c.querySelector('.cw-quiz__r-ask');
      if(ask){
        const panel=ask.querySelector('[data-ask-panel]'), fab=ask.querySelector('.cw-quiz__ask-fab'), emailEl=ask.querySelector('[data-ask-email]');
        if(emailEl && this.S.email) emailEl.value=this.S.email;
        ask.querySelectorAll('[data-ask-toggle]').forEach(t=>t.addEventListener('click',()=>{
          const open=panel.hasAttribute('hidden');
          if(open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden','');
          if(fab) fab.setAttribute('aria-expanded',String(open));
          if(open && emailEl) setTimeout(()=>{try{emailEl.focus();}catch(_){}} ,60);
        }));
        ask.querySelector('[data-ask-send]')?.addEventListener('click',()=>this._sendAsk(ask));
      }
      // "Kontaktiere uns gerne" scrollt zum Kontaktformular (statt mailto)
      c.querySelector('[data-scroll-contact]')?.addEventListener('click',e=>{e.preventDefault();const f=this.querySelector('[data-contact-native]');if(f){try{f.scrollIntoView({behavior:'smooth',block:'center'});}catch(_){}const em=f.querySelector('[name="contact[email]"]');if(em)setTimeout(()=>{try{em.focus();}catch(_){}} ,500);}});
      // Produktbeschreibung: "Mehr anzeigen" nur, wenn gekuerzt wird (weitere Absaetze oder >4 Zeilen)
      const desc=c.querySelector('[data-desc]');
      if(desc){
        const body=desc.querySelector('.cw-quiz__desc-body'),tg=desc.querySelector('[data-desc-toggle]');
        requestAnimationFrame(()=>{
          const first=body.firstElementChild;
          const clipped=first && first.clientHeight>0 ? first.scrollHeight>first.clientHeight+1 : body.textContent.trim().length>200;
          tg.hidden=!(body.children.length>1 || clipped);
        });
        tg.addEventListener('click',()=>{
          const open=desc.classList.toggle('is-collapsed')===false;
          tg.textContent=open?tt('desc_less','Weniger anzeigen'):tt('desc_more','Mehr anzeigen');
          tg.setAttribute('aria-expanded',String(open));
        });
      }
      // A3: Klick auf eine Angaben-Zeile springt zum jeweiligen Schritt
      c.querySelectorAll('[data-goto]').forEach(b=>b.addEventListener('click',()=>this._nav(b.dataset.goto)));
      // Bundle-Card Toggle (nur sichtbar/aktiv auf Mobile via CSS).
      // Klick auf den Header-Bereich klappt die Card auf/zu. Buttons im Header werden nicht abgefangen.
      c.querySelectorAll('.cw-quiz__bundle--collapsible [data-bundle-toggle]').forEach(toggle => {
        toggle.addEventListener('click', e => {
          if(e.target.closest('button, a')) return;
          const card = toggle.closest('.cw-quiz__bundle');
          if(card) card.classList.toggle('cw-quiz__bundle--collapsed');
        });
      });
      // Tooltips: hover on desktop, tap on mobile
      c.querySelectorAll('.cw-quiz__info-tip').forEach(el=>{
        const showTip=()=>{
          c.querySelectorAll('.cw-quiz__tooltip-active').forEach(t=>t.remove());
          const tip=document.createElement('div');tip.className='cw-quiz__tooltip-active';tip.textContent=el.dataset.tip;
          el.parentElement.style.position='relative';
          el.parentElement.appendChild(tip);
          return tip;
        };
        // Desktop hover
        el.addEventListener('mouseenter',()=>{const t=showTip();el.addEventListener('mouseleave',()=>t.remove(),{once:true});});
        // Mobile tap
        el.addEventListener('touchstart',(e)=>{
          e.preventDefault();
          const t=showTip();
          const dismiss=()=>{t.remove();document.removeEventListener('touchstart',dismiss);};
          setTimeout(()=>document.addEventListener('touchstart',dismiss),10);
        },{passive:false});
      });
    }

    _restart() {
      // Alle Eingaben BEHALTEN – User ändert nur was er will.
      // Gift-Daten bleiben ebenfalls. Geschenk-Gate wird nicht erneut gezeigt (Cookie/Session greift).
      this._hist=[];
      this._lastHash=null; // Force re-animation bei "Jetzt berechnen"
      this.S.dirty=false;
      this._nav('1',false);
    }

    _getProductImage(handle) {
      return this._prodImg[handle] || null;
    }

    _loadSpeakerHero(handle) {
      const container = this.querySelector('[data-speaker-hero]');
      if(!container) return;

      var imgData = this._prodImg[handle];
      if(!imgData) return;

      // Farb-Mapping: JS-State ("weiss") auf Shopify-Varianten-Name ("weiß")
      var colorMap = {weiss:'weiß',schwarz:'schwarz',silber:'silber'};
      var color = this.S.farbe || 'default';
      var mappedColor = colorMap[color] || color;

      var url;
      if(typeof imgData === 'object') {
        url = imgData[mappedColor] || imgData[color] || imgData['default'] || '';
      } else {
        url = imgData;
      }

      // URL-Check: akzeptiert "http...", "//..." (protokoll-relativ) und "/..."
      // (wurzel-relativ - so liefert der theme-dev-Server die CDN-Pfade)
      if(url && (url.indexOf('http') === 0 || url.charAt(0) === '/')) {
        container.innerHTML = '<img src="' + url + '" alt="' + (NAMES[handle]||'') + '" style="border-radius:14px">';
      }
    }

    // ── Variant Loader ────────────────────────────────────────────────────
    async getVarId(handle,color) {
      const k=`${handle}:${color||'default'}`;if(this._vc[k])return this._vc[k];
      const r=await fetch(`/products/${handle}.json`,{headers:{Accept:'application/json'}});
      if(!r.ok) throw new Error(`Product "${handle}" not found`);
      const d=await r.json(),vs=d.product?.variants;if(!vs?.length) throw new Error(`No variants for "${handle}"`);
      // Farb-Match umlaut-/scharfes-s-tolerant: intern 'weiss' muss auch die
      // Shopify-Variante 'ß'-Schreibweise ("Weiß") matchen, sonst landet per
      // Fallback vs[0] die falsche Farbe im Warenkorb. ß->ss, Akzente weg.
      const nrm=s=>String(s||'').toLowerCase().replace(/ß/g,'ss').normalize('NFD').replace(/[̀-ͯ]/g,'').trim();
      const c=color?nrm(color):null;
      const v=(c?vs.find(v=>nrm(v.option1)===c)||vs.find(v=>nrm(v.title).includes(c)):null)||vs[0];
      this._vc[k]=v.id;return v.id;
    }

    // ── Verfuegbarkeit / Bestands-Awareness (Weg 1, inventory_policy 'deny') ─
    // Quelle: Ajax-Produkt-JSON /products/<handle>.js -> variant.available spiegelt
    // bei 'deny' den echten Bestand (das .json-Endpoint liefert KEIN available).
    // ALLES fail-safe: bei Fehler / unbekanntem Feld gilt der Artikel als lieferbar
    // -> exakt bisheriges Verhalten, nie faelschlich blocken.
    async _prodJs(handle){
      this._pjs = this._pjs || {};
      if(this._pjs[handle] !== undefined) return this._pjs[handle];
      try {
        const r = await fetch(`/products/${handle}.js`, { headers:{ Accept:'application/json' } });
        this._pjs[handle] = r.ok ? await r.json() : null;
      } catch(_){ this._pjs[handle] = null; }
      return this._pjs[handle];
    }
    async _isAvailable(handle, color){
      const p = await this._prodJs(handle);
      const vs = p && p.variants;
      if(!vs || !vs.length) return true;           // unbekannt -> lieferbar
      const c = color ? NRM(color) : null;
      const v = (c ? vs.find(x=>NRM(x.option1)===c) || vs.find(x=>NRM(x.title).includes(c)) : null) || vs[0];
      return v ? v.available !== false : true;      // nur bei explizit false blocken
    }
    // Varianten-ID aus dem bereits geladenen .js-Cache (kein Extra-Fetch). null = nicht im Cache.
    _vidFromCache(handle, color){
      const p = this._pjs && this._pjs[handle];
      const vs = p && p.variants;
      if(!vs || !vs.length) return null;
      const c = color ? NRM(color) : null;
      const v = (c ? vs.find(x=>NRM(x.option1)===c) || vs.find(x=>NRM(x.title).includes(c)) : null) || vs[0];
      return v ? v.id : null;
    }
    // true, wenn ALLE Zeilen eines Pakets in `color` lieferbar sind (farblose Artikel
    // farbunabhaengig; farbige muessen die Farbe anbieten UND lieferbar sein).
    async _rowsAllAvailable(rows, color){
      for(const li of rows){
        const h = li.getAttribute('data-av-h');
        if(li.hasAttribute('data-av-c')){
          if(!(COLOR_AVAIL[h]||[]).includes(color)) return false;
          if(!(await this._isAvailable(h, color))) return false;
        } else if(!(await this._isAvailable(h, null))) return false;
      }
      return true;
    }
    // Ergebnis-Karten nachtraeglich mit Verfuegbarkeit anreichern (nicht blockierend,
    // laeuft nach dem Render). Farb-Swap-Vorschlag, wenn EINE andere angebotene Farbe
    // das ganze System sofort lieferbar macht (Julius: silber weg -> weiss ok). Sonst
    // klarer Hinweis + CTA -> "Verfuegbarkeit anfragen". Nie Produkttyp/Sub tauschen.
    async _decorateAvail(){
      const cards = [...this.querySelectorAll('[data-bundle-key]')];
      for(const card of cards){
        const rows = [...card.querySelectorAll('li[data-av-h]')];
        let anyOut = false;
        for(const li of rows){
          const ok = await this._isAvailable(li.getAttribute('data-av-h'), li.getAttribute('data-av-c') || null);
          li.classList.toggle('cw-quiz__bundle-item--out', !ok);
          let tag = li.querySelector('[data-av-tag]');
          if(!ok){
            anyOut = true;
            if(!tag){ tag = document.createElement('span'); tag.setAttribute('data-av-tag',''); tag.className = 'cw-quiz__avail-tag'; li.querySelector('.cw-quiz__bundle-item-name')?.appendChild(tag); }
            tag.textContent = ' - ' + tt('avail_out','aktuell nicht lieferbar');
          } else if(tag){ tag.remove(); }
        }
        const cta = card.querySelector('[data-bundle-cta]');
        let notice = card.querySelector('[data-av-notice]');
        card.querySelector('[data-av-alt]')?.remove();
        card.querySelector('[data-av-notify]')?.remove();
        if(anyOut){
          const bk = card.getAttribute('data-bundle-key');
          if(!notice){
            notice = document.createElement('p');
            notice.setAttribute('data-av-notice','');
            notice.className = 'cw-quiz__avail-notice';
            if(cta && cta.parentNode) cta.parentNode.insertBefore(notice, cta);
          }
          notice.textContent = tt('avail_notice','Teile deines Systems sind aktuell nicht lieferbar - typischerweise in unter 3 Wochen wieder verfügbar.');
          // 1) Sofort lieferbare Alternativen (Bild-Popup) - primaer, gross wie CTA.
          let ab = document.createElement('button');
          ab.type = 'button'; ab.setAttribute('data-av-alt',''); ab.className = 'cw-quiz__bundle-cta cw-quiz__avail-alt';
          ab.textContent = tt('alt_open','Sofort in anderer Farbe');
          ab.addEventListener('click', ()=>this._openAltColor(bk));
          notice.after(ab);
          // 2) System reservieren (CTA umgewidmet, Ghost-Look). Interim: -> Kontaktformular.
          if(cta){ cta.dataset.avOut = '1'; cta.dataset.avReserve = '1'; cta.classList.add('cw-quiz__bundle-cta--ghost'); cta.textContent = tt('alt_reserve','System reservieren'); }
          // 3) Informiere mich, wenn wieder verfuegbar (nutzt die E-Mail-Erfassung).
          let nb = document.createElement('button');
          nb.type = 'button'; nb.setAttribute('data-av-notify',''); nb.className = 'cw-quiz__avail-notify';
          nb.textContent = tt('alt_notify','Informiere mich, wenn wieder verfügbar');
          nb.addEventListener('click', ()=>this._saveSystem(bk, nb));
          if(cta && cta.parentNode) cta.parentNode.insertBefore(nb, cta.nextSibling);
        } else {
          notice?.remove();
          if(cta){ cta.classList.remove('cw-quiz__bundle-cta--ghost'); delete cta.dataset.avReserve; }
        }
      }
    }
    // Zum nativen Kontakt-/Anfrageformular scrollen (existiert unter [data-contact-native]).
    _gotoContact(){
      const f = this.querySelector('[data-contact-native]');
      if(!f) return;
      try{ f.scrollIntoView({ behavior:'smooth', block:'center' }); }catch(_){}
      const em = f.querySelector('[name="contact[email]"]');
      if(em) setTimeout(()=>{ try{ em.focus(); }catch(_){} }, 400);
    }

    // ── Alternative-Farbe-Popup (Phase A) ──────────────────────────────────
    // Bild-Popup mit den SOFORT lieferbaren Kombinationen des empfohlenen Systems.
    // Nur Farbe/Weglassen des Subwoofers - nie Produkttyp tauschen. Alles fail-safe.
    _bindAltColor(){
      const m = this._modal('altcolor'); if(!m) return;
      const close = () => this._closeMod(m);
      m.querySelectorAll('[data-action="altcolor-close"]').forEach(b => b.addEventListener('click', close));
      // Klick neben das Popup (auf die Modal-Flaeche, nicht auf den Inhalt) schliesst.
      m.addEventListener('click', e => { if(e.target === m) close(); });
      document.addEventListener('keydown', e => { if(e.key === 'Escape' && !m.hidden) close(); });
    }
    _comboLabel(items){
      return items.filter(i=>i.c!=null).map(i => (NAMES[i.h]||i.h) + ' ' + (COLOR_LBL[i.c]||i.c)).join(' + ');
    }
    // Alle sofort lieferbaren Kombinationen fuer ein Bundle generieren (max 4, kuratiert).
    async _buildCombos(key){
      const sys = this.calculateSystem(), b = sys.bundles[key]; if(!b) return [];
      const base = this.bundleItems(b);
      const wish = this.S.farbe;
      const colored = base.filter(i=>i.c!=null).map(i=>i.h);
      const cache = {};
      const isAv = async (h,c) => { const k=h+'|'+(c||''); if(cache[k]===undefined) cache[k]=await this._isAvailable(h,c); return cache[k]; };
      const itemsFor = (map, drop) => base.filter(i=>!(drop && drop.includes(i.h))).map(i => i.c!=null ? {...i, c:(map[i.h]||i.c)} : i);
      const allAv = async (items) => { for(const it of items){ if(!(await isAv(it.h, it.c))) return false; } return true; };
      const combos = [], seen = new Set();
      const push = (items, suffix) => { const sig=items.map(i=>i.h+':'+(i.c||'-')).join('|'); if(seen.has(sig)) return; seen.add(sig); combos.push({ items, label:this._comboLabel(items)+(suffix||'') }); };
      // beste Farbe je farbiger Komponente (Wunsch behalten, sonst erste lieferbare)
      const best = {};
      for(const h of colored){
        let pick = null;
        for(const c of [wish,'weiss','silber','schwarz']){ if((COLOR_AVAIL[h]||[]).includes(c) && await isAv(h,c)){ pick=c; break; } }
        best[h] = pick;
      }
      // (1) beste Kombi (Wunschfarbe wo moeglich, Rest angepasst)
      if(colored.length && colored.every(h=>best[h])){ const items=itemsFor(best,null); if(await allAv(items)) push(items); }
      // (2) je Einheitsfarbe, wenn alle farbigen Komponenten sie anbieten + lieferbar
      for(const c of ['weiss','silber','schwarz']){
        if(!colored.length || !colored.every(h=>(COLOR_AVAIL[h]||[]).includes(c))) continue;
        const map={}; colored.forEach(h=>map[h]=c);
        const items=itemsFor(map,null); if(await allAv(items)) push(items);
      }
      // (3) ohne Subwoofer
      const subH = this._effSub(b);
      if(b.sub>0 && subH){
        const map={}; colored.forEach(h=>{ if(h!==subH) map[h]=best[h]||wish; });
        const items=itemsFor(map,[subH]);
        if(items.some(i=>i.c!=null) && await allAv(items)) push(items, ' ' + tt('alt_nosub','(ohne Subwoofer)'));
      }
      return combos.slice(0,4);
    }
    _comboCard(c, idx){
      const raw = c.items.reduce((s,i)=>s + (PRICES[i.h]||0)*i.q, 0);
      const pct = this.S.discPct || 0;
      const price = pct ? raw*(1-pct/100) : raw;
      const first = c.items.find(i=>i.c!=null) || c.items[0];
      const colorMap = { weiss:'weiß', schwarz:'schwarz', silber:'silber' };
      const imgs = this._prodImg[first.h]; let url='';
      if(imgs){ url = (typeof imgs==='object') ? (imgs[colorMap[first.c]||first.c] || imgs['default'] || '') : imgs; }
      const img = (url && (url.indexOf('http')===0 || url.charAt(0)==='/')) ? '<img src="'+url+'" alt="" class="cw-quiz__combo-img" loading="lazy">' : '';
      return '<button type="button" class="cw-quiz__combo" data-combo-idx="'+idx+'">'
        + img
        + '<span class="cw-quiz__combo-info"><span class="cw-quiz__combo-label">'+esc(c.label)+'</span>'
        + '<span class="cw-quiz__combo-price">'+esc(tpl(tt('b_price','Systempreis: {price} zzgl. MwSt'),{price:fmtEur(price)}))+'</span></span>'
        + '<span class="cw-quiz__combo-cta">'+esc(tt('alt_choose','Auswählen'))+'</span>'
        + '</button>';
    }
    async _openAltColor(key){
      const m = this._modal('altcolor'); const body = m && m.querySelector('[data-altcolor-body]');
      if(!m || !body) return;
      body.innerHTML = '<p class="cw-quiz__altcolor-msg">'+esc(tt('alt_loading','Lieferbare Varianten werden geladen…'))+'</p>';
      this._openMod(m);
      try{
        const combos = await this._buildCombos(key);
        if(!combos.length){ body.innerHTML = '<p class="cw-quiz__altcolor-msg">'+esc(tt('alt_empty','Aktuell ist keine Farbe sofort lieferbar.'))+'</p>'; return; }
        body.innerHTML = combos.map((c,i)=>this._comboCard(c,i)).join('');
        body.querySelectorAll('[data-combo-idx]').forEach(btn => btn.addEventListener('click', ()=>{
          const c = combos[+btn.dataset.comboIdx]; if(c) this._addCombo(c, key, btn);
        }));
      }catch(e){ body.innerHTML = '<p class="cw-quiz__altcolor-msg">'+esc(tt('alt_empty','Aktuell ist keine Farbe sofort lieferbar.'))+'</p>'; console.error('[Quiz alt]', e); }
    }
    async _addCombo(c, key, btn){
      const m = this._modal('altcolor'); const body = m && m.querySelector('[data-altcolor-body]');
      // "In den Warenkorb"-Klick (andere Farbe) zaehlen (1x/Session).
      cwTrack('WarenkorbKlick', {quelle:'kalkulator', bundle:key, dest:'combo'});
      // Sofortiges Feedback: Popup-Inhalt gleich auf "wird gelegt".
      if(body) body.innerHTML = '<p class="cw-quiz__altcolor-msg">'+esc(tt('alt_adding','Wird in den Warenkorb gelegt…'))+'</p>';
      // SOFORT adden (wie beim Haupt-CTA) - das Geschenk kommt danach als Zugabe.
      try{
        // IDs aus dem bereits geladenen .js-Cache (kein Extra-.json-Fetch); Fallback getVarId.
        const ids = await Promise.all(c.items.map(async i => ({ id: this._vidFromCache(i.h, i.c) || await this.getVarId(i.h, i.c), quantity: i.q })));
        try{
          const cart = await (await fetch('/cart.js',{headers:{Accept:'application/json'}})).json();
          const set = new Set(ids.map(i=>i.id)); const upd = {};
          cart.items.forEach(ci=>{ if(set.has(ci.variant_id)) upd[ci.variant_id]=0; });
          if(Object.keys(upd).length) await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd})});
        }catch(_){}
        const attrs = this._comboAttrs(c, key);
        const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:ids,attributes:attrs})});
        if(!r.ok) throw new Error('Cart '+r.status);
        const comboNet = c.items.reduce((sum,i)=>sum+(PRICES[i.h]||0)*i.q, 0) * (1-(this.S.discPct||0)/100);
        await this._trackCartSuccess(key, 'combo', comboNet, ids.length, 'andere_farbe');
        try{ await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})}); }catch(_){}
      }catch(e){ if(body) body.innerHTML = '<p class="cw-quiz__altcolor-msg">'+esc(tt('error_text','Da ist etwas schiefgegangen.'))+'</p>'; console.error('[Quiz addCombo]', e); return; }
      // Item drin. Geschenk als Zugabe; Farb-Popup schliessen, Finalize patcht + leitet weiter.
      const finalize=()=>this._finalizeCombo(c, key);
      if(this._giftGate(finalize, 220)){ this._closeMod(m); return; }
      finalize();
    }

    async _finalizeCombo(c, key){
      try{ await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:this._comboAttrs(c, key)})}); }catch(_){}
      this._gotoCart('combo');
    }

    _comboAttrs(c, key){
      const s = this.S, p = this.resolveProducts();
      const subH = this._effSub(this.calculateSystem().bundles[key]);
      const colors = [...new Set(c.items.filter(i=>i.c!=null).map(i=>i.c))];
      const subItem = c.items.find(i => i.h===subH);
      const spkItem = c.items.find(i => p && i.h===p.speaker);
      return {
        quiz_source:'true',quiz_branche:s.branche||'',quiz_flaeche_qm:String(s.raumgroesse),
        quiz_deckenhoehe_m:String(s.deckenhoehe_m),quiz_abhaengung_cm:String(s.abhaengung_cm||0),
        quiz_installationshoehe_m:Number(s.installH).toFixed(2),quiz_qm_pro_speaker:String(Math.round(s.qmps)),
        quiz_ohr_hoehe:String(s.ohrH),quiz_bundle:key,quiz_speaker_typ:p.speaker,
        quiz_speaker_anzahl:String(spkItem?spkItem.q:0),quiz_sub_anzahl:String(subItem?subItem.q:0),
        quiz_farbe: colors.length>1 ? 'gemischt' : (colors[0]||s.farbe||''),
        quiz_montage:s.montage_typ||'',quiz_geschenk_typ:s.giftKat||'keins',
        quiz_rabatt_prozent:String(s.discPct||0),quiz_garantie_zusatz_jahre:String(s.garZus||0),
        quiz_email:s.email||'',installation_gewuenscht:String(s.installWanted),
        quiz_geschenk_abgelehnt:s.giftKat?'false':'true',quiz_saved:'false',quiz_alt_farbe:'true'
      };
    }

    // ── Reservieren (Phase B) ──────────────────────────────────────────────
    // Popup erfasst Fiskaldaten + Name/Tel/E-Mail (Pflicht), validiert die USt-ID
    // ueber DENSELBEN Worker-Endpoint /vat/validate (single-source) und POSTet an
    // /reserve -> unbezahlte Draft Order. Kein Geld. Bestaetigungs-Ansicht danach.
    _bindReserve(){
      const m = this._modal('reserve'); if(!m) return;
      const close = () => this._closeMod(m);
      m.querySelectorAll('[data-action="reserve-close"]').forEach(b => b.addEventListener('click', close));
      m.addEventListener('click', e => { if(e.target === m) close(); });
      document.addEventListener('keydown', e => { if(e.key === 'Escape' && !m.hidden) close(); });
      const cty = m.querySelector('[data-reserve-country]'), itBox = m.querySelector('[data-reserve-it]');
      if(cty && itBox) cty.addEventListener('change', () => { itBox.hidden = (cty.value !== 'IT'); });
      const sub = m.querySelector('[data-reserve-submit]');
      if(sub) sub.addEventListener('click', () => this._submitReserve());
    }
    _openReserve(key){
      this._reserveKey = key;
      const m = this._modal('reserve'); if(!m) return;
      const form = m.querySelector('[data-reserve-form]'), done = m.querySelector('[data-reserve-done]');
      if(form) form.hidden = false; if(done) done.hidden = true;
      const err = m.querySelector('[data-reserve-error]'); if(err){ err.hidden = true; err.textContent = ''; }
      const sub = m.querySelector('[data-reserve-submit]'); if(sub){ sub.disabled = false; sub.textContent = tt('res_submit','Verbindlich reservieren'); }
      const cty = m.querySelector('[data-reserve-country]'), itBox = m.querySelector('[data-reserve-it]');
      if(cty && itBox) itBox.hidden = (cty.value !== 'IT');
      this._openMod(m);
    }
    async _submitReserve(){
      const m = this._modal('reserve'); if(!m) return;
      const q = sel => m.querySelector(sel);
      const val = sel => ((q(sel) || {}).value || '').trim();
      const err = q('[data-reserve-error]');
      const showErr = msg => { if(err){ err.textContent = msg || ''; err.hidden = !msg; } };
      const country = (q('[data-reserve-country]') || {}).value || '';
      const company = val('[data-reserve-company]');
      const vat = val('[data-reserve-vat]');
      const sdi = val('[data-reserve-sdi]');
      const pec = val('[data-reserve-pec]');
      const firstname = val('[data-reserve-firstname]');
      const lastname = val('[data-reserve-lastname]');
      const name = (firstname + ' ' + lastname).trim();
      const phoneCode = (q('[data-reserve-phone-code]') || {}).value || '';
      const phoneNum = val('[data-reserve-phone]');
      const phone = phoneNum ? (phoneCode + ' ' + phoneNum).trim() : '';
      const email = val('[data-reserve-email]');
      if(!country || company.length < 2 || vat.length < 2 || !firstname || !lastname || !phoneNum || !email || !validEmail(email)){
        showErr(tt('res_err_required','Bitte fülle alle Pflichtfelder aus.')); return;
      }
      if(country === 'IT' && !sdi){ showErr(tt('res_err_required','Bitte fülle alle Pflichtfelder aus.')); return; }
      const btn = q('[data-reserve-submit]'); const orig = btn && btn.textContent;
      if(btn){ btn.disabled = true; btn.textContent = tt('res_checking','Wird geprüft …'); }
      showErr('');
      const reset = () => { if(btn){ btn.disabled = false; btn.textContent = orig || tt('res_submit','Verbindlich reservieren'); } };
      try{
        // USt-ID validieren - single-source ueber den Worker. CH/LI: kein VIES -> 'format'.
        let vat_validated = 'format';
        if(country !== 'CH' && country !== 'LI'){
          const vurl = this.dataset.vatUrl || 'https://conowave-erp-worker.conowave.workers.dev/vat/validate';
          let res = null;
          try { res = await (await fetch(vurl, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ vatId: vat }) })).json(); }
          catch(_) { res = { status: 'service_unavailable' }; }
          const st = (res && res.status) || 'format';
          if(st === 'invalid' || (res && res.valid === false)){ reset(); showErr(tt('res_err_vat','Diese USt-ID ist nicht gültig. Bitte prüfe die Nummer.')); return; }
          vat_validated = (st === 'service_unavailable') ? 'pending' : ((st === 'valid' || (res && res.valid === true)) ? 'vies' : 'format');
        }
        // System (Varianten) aus dem reservierten Bundle aufloesen.
        const sys = this.calculateSystem(), b = sys.bundles[this._reserveKey];
        if(!b){ reset(); showErr(tt('res_err_send','Das hat gerade nicht geklappt. Bitte versuch es erneut oder schreib uns.')); return; }
        const items = this.bundleItems(b);
        const systemLabel = items.map(i => i.q + '× ' + (NAMES[i.h]||i.h) + (i.c ? ' (' + (COLOR_LBL[i.c]||i.c) + ')' : '')).join(', ');
        const lineItems = await Promise.all(items.map(async i => ({ variant_id: this._vidFromCache(i.h, i.c) || await this.getVarId(i.h, i.c), quantity: i.q })));
        const rurl = this.dataset.reserveUrl || 'https://conowave-erp-worker.conowave.workers.dev/reserve';
        const r = await fetch(rurl, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({
          items: lineItems, system_label: systemLabel, name: name, phone: phone, email: email, company: company,
          vat_id: vat, vat_validated: vat_validated, ship_country: country, bill_country: country,
          sdi_code: (country === 'IT' ? sdi : ''), pec: (country === 'IT' ? pec : '')
        }) });
        const data = await r.json().catch(() => ({}));
        if(!r.ok || !data.ok){ reset(); showErr(tt('res_err_send','Das hat gerade nicht geklappt. Bitte versuch es erneut oder schreib uns.')); return; }
        const form = q('[data-reserve-form]'), done = q('[data-reserve-done]');
        if(form) form.hidden = true; if(done) done.hidden = false;
      }catch(e){ reset(); showErr(tt('res_err_send','Das hat gerade nicht geklappt. Bitte versuch es erneut oder schreib uns.')); console.error('[Quiz reserve]', e); }
    }

    // ── Add to Cart ───────────────────────────────────────────────────────
    async _addToCart(key,btn,dest) {
      // OOS-Karte: der (umgewidmete) CTA "System reservieren" oeffnet das Reserve-Popup
      // statt in den Warenkorb/Checkout zu laufen.
      if(btn && btn.dataset && btn.dataset.avReserve){ this._openReserve(key); return; }
      const sys=this.calculateSystem(),b=sys.bundles[key];if(!b)return;
      // "In den Warenkorb"-Klick zaehlen (1x/Session, Dedup ueber cwTrack).
      cwTrack('WarenkorbKlick', {quelle:'kalkulator', bundle:key, dest:dest||'checkout'});
      const orig=btn?.textContent;if(btn){btn.disabled=true;btn.textContent=tt('cta_loading','Wird geladen…');}
      // SOFORT in den Warenkorb - UNABHAENGIG vom Geschenk. Frueher hing der Add hinter
      // dem Geschenk-Popup; wer es wegklickte oder die Seite verliess, addete nie. Jetzt
      // ist das System sofort drin, das Geschenk kommt danach als nicht-blockierende Zugabe.
      // Die Geschenk-Entscheidung patcht nur noch die Garantie-Attribute + leitet weiter
      // (_finalizeCart). Mit dem Geschenk hat das Adden damit nichts mehr zu tun.
      try {
        const items=this.bundleItems(b);
        const ids=await Promise.all(items.map(async i=>({id:this._vidFromCache(i.h,i.c)||await this.getVarId(i.h,i.c),quantity:i.q})));

        // Weg-1 Verfuegbarkeits-Guard: nichts blind adden, wenn ein Teil nicht lieferbar
        // ist -> zur Anfrage leiten statt in den 422/generischen Fehler zu laufen.
        // Fail-safe: bei unklarer Verfuegbarkeit normal fortfahren (bisheriges Verhalten).
        try {
          for(const it of items){
            if(!(await this._isAvailable(it.h, it.c))){
              if(btn){ btn.disabled=false; btn.textContent = orig || tt('cta_cart','In den Warenkorb'); }
              this._gotoContact();
              return;
            }
          }
        } catch(_){}

        const newVarIds=new Set(ids.map(i=>i.id));
        try {
          const cartRes=await fetch('/cart.js',{headers:{Accept:'application/json'}});
          const cart=await cartRes.json();
          const updates={};
          cart.items.forEach(ci=>{if(newVarIds.has(ci.variant_id))updates[ci.variant_id]=0;});
          if(Object.keys(updates).length) await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
        } catch(_){}

        const attrs=this._quizAttrs(key,b,dest);
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:ids,attributes:attrs})});
        if(!r.ok)throw new Error(`Cart ${r.status}`);
        // quelle 'gespeichert' = Warenkorb-Weg mit quiz_saved (dest 'cart', Buttons [data-bundle-cart])
        await this._trackCartSuccess(key, dest||'checkout', this.bDisc(b), ids.length, dest==='cart'?'gespeichert':'warenkorb');
        try{await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})});}catch(_){}
        this.S.dirty=false;
        if(btn){ btn.disabled=false; btn.textContent = orig || tt('cta_cart','In den Warenkorb'); }
      } catch(e){
        this._showErr();if(btn){btn.disabled=false;btn.textContent=orig||tt('cta_cart','In den Warenkorb');}
        console.error('[Quiz]',e);
        return;
      }
      // Item ist jetzt sicher im Warenkorb. Geschenk-Popup als Zugabe (nicht blockierend):
      // oeffnet es sich, laeuft _finalizeCart erst bei Claim/Decline; sonst sofort.
      const finalize=()=>this._finalizeCart(key,b,dest);
      if(this._giftGate(finalize)) return;
      finalize();
    }

    // Geschenk-Entscheidung gefallen (oder kein Geschenk): finalen Gift-Stand als
    // Warenkorb-Attribut nachpatchen, optional ERP-/Lead-Notify (nur mit E-Mail), dann
    // zum Warenkorb. Der Artikel liegt zu diesem Zeitpunkt bereits im Warenkorb.
    async _finalizeCart(key,b,dest){
      const s=this.S;
      try{ await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:this._quizAttrs(key,b,dest)})}); }catch(_){}
      if(s.email){
        const wUrl=this.dataset.workerUrl||'https://conowave-quiz-worker.conowave.workers.dev';
        fetch(wUrl+'/cart-added',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:s.email,bundle_type:key,discount_code:s.discCode||null})}).catch(()=>{});
      }
      this._gotoCart(dest, this._testOfferCode(key, b));
    }

    // Rabattcode fuer das Canto-Test-Festpreis-Angebot (im Theme-Editor hinterlegt). Klein =
    // ohne Sub, gross = mit Sub. Nur wenn Canto empfohlen und ein Code gesetzt ist.
    _testOfferCode(key, b){
      if(key!=='test') return null;
      const rp=this.resolveProducts(); if(!rp || rp.speaker!=='canto-smart') return null;
      const code=((b.sub>0?this.dataset.testCodeBig:this.dataset.testCodeSmall)||'').trim();
      return code||null;
    }

    // WICHTIG: bewusst auf /cart (nicht direkt /checkout), damit jeder Quiz-Kunde durch den
    // Warenkorb laeuft (SDI/PEC-Erfassung fuer IT-Geschaeftskunden). Rabatt bleibt erhalten:
    // /discount/CODE?redirect=/cart wendet den Code an. overrideCode = Test-Angebots-Code,
    // sonst nur Karte A (echter Code); Karte B ist ein Tracking-Token und darf NICHT in den Redirect.
    _gotoCart(dest, overrideCode){
      const s=this.S;
      if(dest==='cart'){ window.location.href='/cart'; return; }
      const code = overrideCode || (s.discCode && s.giftKat === 'A' ? s.discCode : null);
      window.location.href = code
        ? `/discount/${encodeURIComponent(code)}?redirect=/cart`
        : '/cart';
    }

    // Warenkorb-Attribute (quiz_*) aus dem aktuellen Stand. Wird beim Add und erneut beim
    // Finalisieren gebaut, damit die Geschenk-Entscheidung sauber nachgepatcht wird.
    _quizAttrs(key,b,dest){
      const s=this.S,p=this.resolveProducts();
      return {
        quiz_source:'true',quiz_branche:s.branche||'',quiz_flaeche_qm:String(s.raumgroesse),
        quiz_deckenhoehe_m:String(s.deckenhoehe_m),quiz_abhaengung_cm:String(s.abhaengung_cm||0),
        quiz_installationshoehe_m:Number(s.installH).toFixed(2),quiz_qm_pro_speaker:String(Math.round(s.qmps)),
        quiz_ohr_hoehe:String(s.ohrH),quiz_bundle:key,quiz_speaker_typ:p.speaker,
        quiz_speaker_anzahl:String(b.spk),quiz_sub_anzahl:String(b.sub),
        quiz_farbe:s.farbe||'',quiz_montage:s.montage_typ||'',
        quiz_geschenk_typ:s.giftKat||'keins',quiz_rabatt_prozent:String(s.discPct||0),
        quiz_garantie_zusatz_jahre:String(s.garZus||0),quiz_email:s.email||'',
        installation_gewuenscht:String(s.installWanted),quiz_geschenk_abgelehnt:s.giftKat?'false':'true',
        quiz_saved: dest==='cart'?'true':'false'
      };
    }

    // Restock-Benachrichtigung ("Informiere mich, wenn wieder verfuegbar", nur OOS-Karten).
    async _saveSystem(key, btn) {
      if(this.S.email) {
        await this._saveInBackground(key, btn);
      } else {
        this._showSaveModal(key, btn, 'notify');
      }
    }

    // "Fuer spaeter speichern" (jede Ergebniskarte): Konfiguration per Mail sichern.
    // Eigener Weg -> Quiz-Worker /save-config (Config-Mail + CleverReach-Lead). NICHT das
    // Restock-/notify. Kein Einmal-pro-Mail-Limit (Geschenk ist separat).
    async _saveConfig(key, btn) {
      if(this.S.email) {
        await this._saveConfigInBackground(key, btn);
      } else {
        this._showSaveModal(key, btn, 'savecfg');
      }
    }

    async _saveConfigInBackground(key, btn) {
      const orig=btn?.textContent;
      if(btn){btn.disabled=true;btn.textContent=tt('b_saving_cfg','Wird gesendet…');}
      try {
        const sys=this.calculateSystem(),b=sys.bundles[key];if(!b)return;
        const items=this.bundleItems(b);
        const s=this.S,p=this.resolveProducts();
        const workerUrl=this.dataset.workerUrl||'https://conowave-quiz-worker.conowave.workers.dev';
        const r=await fetch(workerUrl+'/save-config',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
          email:s.email, bundle_type:key,
          bundle_items:items.map(i=>({handle:i.h,quantity:i.q,variant:i.c||undefined})),
          system_preis_netto:this.bTotal(b), rabatt_prozent:s.discPct||0, discount_code:s.discCode||null,
          quiz_data:{branche:s.branche,flaeche_qm:s.raumgroesse,deckenhoehe_m:s.deckenhoehe_m,installationshoehe_m:Number(s.installH).toFixed(2),montage:s.montage_typ,farbe:s.farbe,speaker_anzahl:this.calculateSystem().n||1,sub_anzahl:b.sub,speaker_typ:p.speaker}
        })});
        if(!r.ok) throw new Error('save-config failed');
        window._cwConfigSaved=true; this.S.systemSaved=true;
        // Meta-Lead: E-Mail-Capture ueber "Fuer spaeter speichern" zaehlt wie ein Geschenk-Claim.
        cwTrack('KalkulatorLead');
        if(btn){btn.textContent=tt('b_saved_cfg','Gespeichert ✓');btn.disabled=true;}
        const hint=btn?.closest('.cw-quiz__bundle')?.querySelector('.cw-quiz__bundle-save-hint');
        if(hint&&s.email) hint.textContent=tpl(tt('mail_sent','Mail ist unterwegs an {email}'),{email:s.email});
      } catch(e){
        console.error('[save-config]',e);
        if(btn){btn.disabled=false;btn.textContent=orig||tt('b_save','System per Mail schicken');}
      }
    }

    async _saveInBackground(key, btn) {
      const orig=btn?.textContent;
      if(btn){btn.disabled=true;btn.textContent=tt('b_saving','Wird eingetragen...');}
      try {
        const sys=this.calculateSystem(),b=sys.bundles[key];if(!b)return;
        const items=this.bundleItems(b);
        const s=this.S,p=this.resolveProducts();
        // Phase C: "Informiere mich, wenn wieder verfuegbar" -> Restock-Watch im ERP-Worker
        // (kein Warenkorb, kein Draft, kein Hold). Der Worker matcht ueber die variant_id auf
        // den Bestand und mailt automatisch, sobald wieder lieferbar. Der Versand-Kanal
        // (n8n heute, spaeter ggf. Klaviyo/CleverReach) ist im Worker gekapselt (sendRestockNotify).
        const systemLabel=items.map(i=>i.q+'× '+(NAMES[i.h]||i.h)+(i.c?' ('+(COLOR_LBL[i.c]||i.c)+')':'')).join(', ');
        const lineItems=await Promise.all(items.map(async i=>({variant_id:this._vidFromCache(i.h,i.c)||await this.getVarId(i.h,i.c),quantity:i.q})));
        const nurl=this.dataset.notifyUrl||'https://conowave-erp-worker.conowave.workers.dev/notify';
        const r=await fetch(nurl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
          email:s.email, items:lineItems, system_label:systemLabel,
          quiz:{branche:s.branche,flaeche_qm:s.raumgroesse,deckenhoehe_m:s.deckenhoehe_m,installationshoehe_m:Number(s.installH).toFixed(2),montage:s.montage_typ,farbe:s.farbe,speaker_anzahl:this.calculateSystem().n||1,sub_anzahl:b.sub,speaker_typ:p.speaker,bundle_type:key}
        })});
        const data=await r.json().catch(()=>({}));
        if(!r.ok||!data.ok) throw new Error('notify failed');

        window._cwConfigSaved=true;
        this.S.systemSaved=true;
        if(btn){btn.textContent=tt('b_saved','Eingetragen ✓');btn.disabled=true;}
        const hint=btn?.closest('.cw-quiz__bundle')?.querySelector('.cw-quiz__bundle-save-hint');
        if(hint&&s.email) hint.textContent=tpl(tt('mail_sent','Mail ist unterwegs an {email}'),{email:s.email});
      } catch(e){
        console.error('[notify]',e);
        if(btn){btn.disabled=false;btn.textContent=orig||tt('save_submit','Benachrichtigen');}
      }
    }

    _showSaveModal(key, btn, mode) {
      const modal = this._modal('save');
      if(!modal) return;
      this._saveModalKey = key;
      this._saveModalBtn = btn;
      this._saveModalMode = mode || 'notify';
      // Text je Modus setzen: 'savecfg' = Konfiguration sichern, 'notify' = Restock-Benachrichtigung.
      const t = modal.querySelector('.cw-quiz__modal-title');
      const p = modal.querySelector('.cw-quiz__modal-text');
      const sub = modal.querySelector('[data-save-form] button[type="submit"]');
      if(this._saveModalMode === 'savecfg') {
        if(t) t.textContent = tt('savecfg_title','System per Mail schicken');
        if(p) p.textContent = tt('savecfg_text','Gib deine E-Mail ein - wir senden dir dein System, damit du es jederzeit wiederfindest.');
        if(sub) sub.textContent = tt('savecfg_submit','Zusenden');
      } else {
        if(t) t.textContent = tt('save_title','Wir sagen dir Bescheid');
        if(p) p.textContent = tt('save_text','Trag deine E-Mail ein - wir melden uns, sobald dein System wieder lieferbar ist.');
        if(sub) sub.textContent = tt('save_submit','Benachrichtigen');
      }
      this._openMod(modal);
    }

    _bindSaveModal() {
      const modal = this._modal('save');
      if(!modal) return;
      const close = () => this._closeMod(modal);
      modal.querySelectorAll('[data-action="save-close"]').forEach(b => b.addEventListener('click', close));
      modal.querySelector('.cw-quiz__modal-backdrop')?.addEventListener('click', close);
      // Geteiltes E-Mail-Modal, zwei Modi (this._saveModalMode): 'savecfg' = Konfiguration sichern
      // (-> /save-config), 'notify' = Restock-Benachrichtigung (-> /notify). Skip = nur abbrechen.
      modal.querySelector('[data-action="save-skip"]')?.addEventListener('click', () => { close(); });
      const form = modal.querySelector('[data-save-form]');
      if(form) form.addEventListener('submit', e => {
        e.preventDefault();
        const emailInput = form.querySelector('input[type="email"]');
        const email = (emailInput?.value || '').trim();
        if(!email || !validEmail(email)) { emailInput?.focus(); return; }
        this.S.email = email;
        close();
        if(this._saveModalMode === 'savecfg') this._saveConfigInBackground(this._saveModalKey || 'premium', this._saveModalBtn);
        else this._saveInBackground(this._saveModalKey || 'premium', this._saveModalBtn);
      });
      document.addEventListener('keydown', e => { if(e.key === 'Escape' && !modal.hidden) close(); });
    }

    _sendSaveEmail(email) {}

    _showErr(){const e=this.querySelector('[data-error]');if(e){e.hidden=false;setTimeout(()=>e.hidden=true,8000);}}

    // ── Dev Reset ─────────────────────────────────────────────────────────
    _styleSlider(sl) {
      if(!sl) return;
      const pct = ((sl.value - sl.min) / (sl.max - sl.min)) * 100;
      sl.style.setProperty('--cw-slider-pct', pct + '%');
    }

    // ── Sidebar ───────────────────────────────────────────────────────────
    _updSidebar() {
      const s=this.S;
      const stepMap={'1':1,'2':2,'3':3,'4':4,'4-schiene':4,'4-schiene_placement':4,'4-typ':4,'4-abhaengung':4,'4-wand_info':4,'5':5};
      const currentStep = stepMap[this._loc] || 0;

      // Schritt-Anzeige
      const stepEl=this.querySelector('[data-sidebar-step]');
      if(stepEl && currentStep > 0) stepEl.textContent=tpl(tt('sidebar_step','Schritt {n} von 5'),{n:currentStep});

      // Werte setzen
      const vals = {
        branche: s.branche ? (BRANCHE_LBL[s.branche]||s.branche) : null,
        flaeche: (s.raumgroesse && this._visitedSteps && this._visitedSteps.has(2)) ? s.raumgroesse+' m\u00B2' : null,
        decke: (s.deckenhoehe_m && this._visitedSteps && this._visitedSteps.has(3)) ? fmtM(s.deckenhoehe_m)+' m' : null,
        montage: s.montage_typ ? ((MONTAGE_LBL[s.montage_typ]||s.montage_typ) + (s.montage_typ==='stromschiene' && s.schiene_platzierung ? (s.schiene_platzierung==='abgehaengt' ? ' ('+tt('platz_abgehaengt_short','abgeh.')+')' : ' ('+tt('platz_decke_short','Decke')+')') : '')) : null,
        farbe: s.farbe ? (COLOR_LBL[s.farbe]||s.farbe) : null
      };

      // Welche Row gehoert zu welchem Step
      const rowStep = {branche:1, flaeche:2, decke:3, montage:4, farbe:5};

      Object.keys(vals).forEach(key => {
        const dd = this.querySelector('[data-sidebar-val="'+key+'"]');
        const row = this.querySelector('[data-sidebar-row="'+key+'"]');
        if(!dd || !row) return;
        if(vals[key]) {
          dd.textContent = vals[key];
          dd.classList.remove('is-empty');
        } else {
          dd.innerHTML = '&ndash;';
          dd.classList.add('is-empty');
        }
        // Aktuelle Zeile hervorheben
        row.classList.toggle('is-current', rowStep[key] === currentStep);
      });
    }

    _bindDev(){const b=this.querySelector('[data-dev-reset]');if(!b)return;b.addEventListener('click',()=>{try{setCk('cw_gift_claimed','',-1);}catch(_){}try{localStorage.removeItem('conowave_gift_claimed');}catch(_){}try{localStorage.removeItem('conowave_gift_data');}catch(_){}try{sessionStorage.removeItem('cw_gift_value');}catch(_){}try{sessionStorage.removeItem('cw_gift_popup_shown');}catch(_){}try{sessionStorage.removeItem('cw_gift_declined');}catch(_){}window.location.reload();});}
  }

  if(!customElements.get('conowave-quiz')) customElements.define('conowave-quiz',CQ);
})();
